<template>
  <form id="mainForm" action="#" method="post">
    <Dialog
      v-model:visible="visible"
      header="Comment"
      :style="{ width: '50rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <div class="grid">
        <div class="col-12">
          <div class="p-fluid">
            <InputText
              type="text"
              name="commentRevise"
              v-model="header.commentRevise"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="No" @click="dismissConfirmation" />
        <Button label="Yes" autofocus @click="saveData" />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="visibleExtend"
      header="Comment"
      :style="{ width: '50rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <div class="grid">
        <div class="col-12">
          <div class="p-fluid">
            <InputText
              type="text"
              name="commentRevise"
              v-model="header.commentRevise"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="No" @click="dismissSuspend" />
        <Button label="Yes" autofocus @click="suspendData" />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="visibleResetVerif"
      header="Comment"
      :style="{ width: '50rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <div class="grid">
        <div class="col-12">
          <div class="p-fluid">
            <InputText
              type="text"
              name="commentRevise"
              v-model="header.commentRevise"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="No" @click="dismissResetVerif" />
        <Button label="Yes" autofocus @click="resetVerifData" />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="visibleClean"
      header="Comment"
      :style="{ width: '50rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <div class="grid">
        <div class="col-12">
          <div class="p-fluid">
            <InputText
              type="text"
              name="commentRevise"
              v-model="header.commentRevise"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="No" @click="dismissClean" />
        <Button label="Yes" autofocus @click="cleanApprover" />
      </template>
    </Dialog>
    <Card>
      <template #title>
        <Toolbar>
          <template #left>
            <div class="p-card-title">
              {{ this.permitNumber }}
            </div>
            <div
              style="margin-left: 10px"
              v-if="mode != this.$FORM_MODE_CREATE"
            >
              <Button
                type="button"
                icon="pi pi-info"
                @click="toggle"
                aria:haspopup="true"
                aria-controls="overlay_panel"
                class="p-button-rounded p-button-outlined p-button-sm"
              />

              <OverlayPanel
                ref="op"
                appendTo="body"
                :showCloseIcon="true"
                id="overlay_panel"
                style="width: 550px"
                :breakpoints="{ '960px': '80vw' }"
              >
                <div class="grid field">
                  <div class="row">
                    <i class="pi pi-plus-circle" />
                    {{ this.$formatDateTime(header.CreatedAt) }}
                  </div>
                  <div class="row">&nbsp;by {{ header.CreatedBy }}</div>
                </div>
                <div class="grid field" v-if="header.EditedAt">
                  <div class="row">
                    <i class="pi pi-pencil" />
                    {{ this.$formatDateTime(header.EditedAt) }}
                  </div>
                  <div class="row">&nbsp;by {{ header.EditedBy }}</div>
                </div>
              </OverlayPanel>
            </div>
          </template>

          <template #right>
            <Button
              icon="pi pi-chevron-left"
              :label="$t('back')"
              class="p-button mr-2"
              @click="backToIndex"
            />

            <!-- <Button icon="pi pi-save" :label="$t('save')" class="p-button-success  mr-2"
                            @click="confirm($event)"
                            v-if="mode != this.$FORM_MODE_VERIFY && this.permitUser == this.userName && (this.permitStatus == 'PRG') && this.permitDelete == 'N' ||
            mode == this.$FORM_MODE_EDIT && this.permitUser == this.userName && this.permitDelete == 'N' && this.permitStatus != 'REJ'" />

                        <Button icon="pi pi-save" :label="$t('save')" class="p-button-success  mr-2"
                            @click="confirmResubmit($event)"
                            v-if="mode == this.$FORM_MODE_EDIT && this.permitUser == this.userName && this.permitDelete == 'N' && this.permitStatus == 'REJ'" /> -->

            <Button
              icon="pi pi-trash"
              label="Delete"
              class="p-button-danger mr-2"
              @click="confirm($event)"
              v-if="mode == this.$FORM_MODE_DELETE && this.permitDelete == 'N'"
            />
            <QRCode
              :refNumber="this.permitNumber"
              :section="'PERMIT'"
              :refId="this.id"
            />
            <Button
              icon="pi pi-save"
              :label="$t('complete')"
              class="p-button-success mr-2"
              @click="confirmVerif($event, 'COM')"
              v-if="
                mode != this.$FORM_MODE_VERIFY &&
                this.permitDelete == 'N' &&
                this.permitVersion == 2
              "
              :disabled="
                this.permitStatus != 'PRG' ||
                this.permitUser != this.userName ||
                this.permitChecklistReviewed == 'N'
              "
            />

            <div v-if="this.permitStatus != 'SUS'">
              <Button
                icon="pi pi-save"
                :label="$t('suspend')"
                class="p-button-danger mr-2"
                @click="confirmSuspend($event)"
                v-if="
                  mode != this.$FORM_MODE_VERIFY && this.permitDelete == 'N'
                "
                :disabled="
                  this.companyCodeUser != this.permitCompanyCode ||
                  (this.permitStatus != 'PRG' && this.permitStatus != 'COM')
                "
              />
            </div>
            <div v-if="this.permitVersion == 2 && this.isGlobalAdmin == 'Y'">
              <Button
                icon="pi pi-save"
                :label="$t('reset_verif')"
                class="p-button-danger mr-2"
                @click="confirmResetVerif($event)"
                v-if="
                  mode != this.$FORM_MODE_VERIFY && this.permitDelete == 'N'
                "
                :disabled="this.permitStatus != 'PRG'"
              />
            </div>
            <div v-else-if="this.permitStatus == 'SUS'">
              <Button
                icon="pi pi-save"
                :label="$t('unsuspend')"
                class="p-button-success mr-2"
                @click="confirmSuspend($event)"
                v-if="
                  mode != this.$FORM_MODE_VERIFY && this.permitDelete == 'N'
                "
                :disabled="this.companyCodeUser != this.permitCompanyCode"
              />
            </div>
            <div v-if="this.permitStatus == 'PRG' && this.isGlobalAdmin == 'Y'">
              <Button
                icon="pi pi-info-circle"
                :label="$t('clean_approver')"
                class="p-button-primary mr-2"
                @click="confirmClean($event)"
                v-if="
                  mode != this.$FORM_MODE_VERIFY && this.permitDelete == 'N'
                "
              />
            </div>

            <div v-if="this.permitVersion == 1">
              <Button
                icon="pi pi-save"
                :label="$t('close_permit')"
                class="p-button-success mr-2"
                @click="confirmVerif($event, 'COM')"
                v-if="
                  mode != this.$FORM_MODE_VERIFY && this.permitDelete == 'N'
                "
                :disabled="
                  this.permitUser != this.userName || this.permitStatus != 'PRG'
                "
              />
            </div>

            <ChangeHistoryTrans
              :data="this.permitNumber"
              :type="'Permit'"
              @close="onModalClose"
              @message="sidebarMessage($event)"
            />

            <ConfirmPopup></ConfirmPopup>
          </template>
        </Toolbar>
      </template>
      <template #content>
        <div class="p-inputtext-sm p-fluid">
          <!-- <BlockUI :blocked="loading" :baseZIndex="1150"> -->
          <div v-if="this.permitVersion == 1">
            <TabView ref="tabViewRef" @tab-change="onTabChange">
              <TabPanel header="General" :key="this.$TAB_SECTION.GNR">
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">General</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirm($event)"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <div class="col-12">
                  <Message severity="info" :closable="false">
                    <table>
                      <tr>
                        <td><b>Caution!</b></td>
                      </tr>
                      <tr>
                        <td>
                          General Data Cannot Be Revised, Please Double Check
                          Your Entries.
                        </td>
                      </tr>
                    </table>
                  </Message>
                </div>
                <div class="grid">
                  <div class="col-6">
                    <FormField
                      :labelName="$t('title')"
                      fieldName="Title"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <InputText
                        name="Title"
                        :class="{ 'p-invalid': submitted && !header.Title }"
                        v-model="header.Title"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit || this.isGeneralFull == true"
                      />
                      <small
                        v-if="
                          header &&
                          !header.Title &&
                          submitted &&
                          mode != this.$FORM_MODE_DELETE
                        "
                        class="p-error"
                        >{{ $t("is_required").replace("Value", $t("title")) }}
                      </small>
                    </FormField>
                    <FormField
                      :labelName="
                        header.Category == this.$PERMIT_CATEGORY.LIVE
                          ? $t('personel_qualifed')
                          : $t('given_to')
                      "
                      fieldName="GivenTo"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <InputText
                        name="GivenTo"
                        :class="{ 'p-invalid': submitted && !header.GivenTo }"
                        v-model="header.GivenTo"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit || this.isGeneralFull == true"
                      />
                      <small
                        v-if="
                          header &&
                          !header.GivenTo &&
                          submitted &&
                          mode != this.$FORM_MODE_DELETE
                        "
                        class="p-error"
                        >{{
                          $t("is_required").replace(
                            "Value",
                            $t("personel_qualifed")
                          )
                        }}
                      </small>
                    </FormField>
                    <FormField
                      :labelName="$t('date')"
                      fieldName="PermitDate"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <DatePicker
                        v-model="header.PermitDate"
                        :class="{
                          'p-invalid': submitted && !header.PermitDate,
                        }"
                        dateFormat="dd/mm/yyyy"
                        inputMask="99/99/9999"
                        momentFormat="DD/MM/YYYY"
                        class="p-inputtext-sm"
                        v-if="header"
                        :minDate="header.workStartDate"
                        :disabled="!canEdit || this.isGeneralFull == true"
                      />
                      <small
                        v-if="
                          header &&
                          !header.PermitDate &&
                          submitted &&
                          mode != this.$FORM_MODE_DELETE
                        "
                        class="p-error"
                        >{{ $t("is_required").replace("Value", $t("date")) }}
                      </small>
                    </FormField>
                    <FormField
                      :labelName="$t('start_time')"
                      fieldName="StartTime"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <div
                        class="field grid"
                        style="margin-bottom: 0 !important"
                      >
                        <div class="col-5">
                          <DatePicker
                            id="calendar-timeonly"
                            :class="{
                              'p-invalid': submitted && !header.StartTime,
                            }"
                            momentFormat="HH:mm"
                            v-if="header"
                            v-model="header.StartTime"
                            timeOnly
                            :disabled="!canEdit || this.isGeneralFull == true"
                          />
                          <small
                            v-if="
                              header &&
                              !header.StartTime &&
                              submitted &&
                              mode != this.$FORM_MODE_DELETE
                            "
                            class="p-error"
                            >{{
                              $t("is_required").replace(
                                "Value",
                                $t("start_time")
                              )
                            }}
                          </small>
                        </div>
                        <label for="FinishTime" class="col-2">Finish</label>
                        <div class="col-5">
                          <DatePicker
                            id="calendar-timeonly"
                            :class="{
                              'p-invalid': submitted && !header.FinishTime,
                            }"
                            momentFormat="HH:mm"
                            v-if="header"
                            v-model="header.FinishTime"
                            timeOnly
                            :disabled="!canEdit || this.isGeneralFull == true"
                          />
                          <small
                            v-if="
                              header &&
                              !header.FinishTime &&
                              submitted &&
                              mode != this.$FORM_MODE_DELETE
                            "
                            class="p-error"
                            >{{ $t("is_required").replace("Value", "Finish") }}
                          </small>
                        </div>
                      </div>
                    </FormField>
                    <FormField
                      :labelName="$t('involved_area')"
                      fieldName="RelatedArea"
                      v-model="header"
                      labelClass="col-4"
                      fieldClass="col-6 md-6"
                    >
                      <CustomSelect
                        v-model="header.RelatedArea"
                        v-if="header"
                        :url="this.$API_URL + 'list/department'"
                        :minLength="0"
                        :filter="true"
                        :params="{ companyCode: header.CompanyCode }"
                        :disabled="!canEdit || this.isGeneralFull == true"
                        @change="changeDept($event)"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('actual_work')"
                      fieldName="Description"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <InputText
                        name="Description"
                        :class="{
                          'p-invalid': submitted && !header.Description,
                        }"
                        v-model="header.Description"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit || this.isGeneralFull == true"
                      />
                      <small
                        v-if="
                          header &&
                          !header.Description &&
                          submitted &&
                          mode != this.$FORM_MODE_DELETE
                        "
                        class="p-error"
                        >{{
                          $t("is_required").replace("Value", $t("actual_work"))
                        }}
                      </small>
                    </FormField>
                  </div>
                  <div class="col-6">
                    <FormField
                      :labelName="$t('permit_number')"
                      fieldName="PermitNumber"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="PermitNumber"
                        v-model="header.PermitNumber"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('status')"
                      fieldName="Status"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="Jsea"
                        v-model="header.Status"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('category')"
                      fieldName="Category"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="Category"
                        v-model="header.Category"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('critical')"
                      fieldName="Critical"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="Critical"
                        v-model="header.Critical"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('created_by')"
                      fieldName="CreatedBy"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="CreatedBy"
                        v-model="header.CreatedBy"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('company_owning')"
                      fieldName="CompanyCode"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="CompanyCode"
                        v-model="header.CompanyCode"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('area_name')"
                      fieldName="UserDeptname"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="UserDeptname"
                        v-model="header.UserDeptname"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('department')"
                      fieldName="AreaName"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="AreaName"
                        v-model="header.AreaName"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('sub_area_name')"
                      fieldName="SubAreaName"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="SubAreaName"
                        v-model="header.SubAreaName"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('spesific_area')"
                      fieldName="SpesificArea"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="SpesificArea"
                        v-model="header.SpesificArea"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                  </div>
                </div>
                <div
                  class="col-12 mt-4"
                  v-if="this.mode != this.$FORM_MODE_CREATE"
                >
                  <TabView>
                    <TabPanel :header="$t('release_approval')">
                      <ChangeHistory
                        v-if="this.header"
                        :modelValue="this.dataModelRelease"
                        :dataRequestLog="this.dataRelease"
                        :mode="this.mode"
                      ></ChangeHistory>
                    </TabPanel>
                    <!-- <TabPanel :header="$t('log_history')">
                      <ChangeHistory
                        v-if="this.header"
                        :modelValue="this.dataModelPermitLogs"
                        :dataRequestLog="this.dataPermitLogs"
                        :mode="this.mode"
                      ></ChangeHistory>
                    </TabPanel> -->
                  </TabView>
                </div>
              </TabPanel>
              <TabPanel
                header="Exec"
                v-if="this.isGeneralFull == true"
                :key="this.$TAB_SECTION.EXEC"
              >
                <!-- <Exec :dataArray="header" :dataModel="dataModelExec" :mode="mode" v-if="header"
                                            :header="header" /> -->
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Exec</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirm($event)"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <div class="col-12">
                  <Message severity="info" :closable="false">
                    <table>
                      <tr>
                        <td><b>Important!</b></td>
                      </tr>
                      <tr>
                        <td>
                          Before starting work, all the items below must be
                          checked first, otherwise work cannot be started.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <small>*To be filled in by the Permit holder</small>
                        </td>
                      </tr>
                    </table>
                  </Message>
                </div>
                <div class="col-12">
                  <div v-if="this.permitCategory == this.$PERMIT_CATEGORY.COWP">
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect1"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect1" class="ml-2"> Sebelum memberi izin melakukan pekerjaan dingin, petugas yang berwenang harus memastikan bahwa pekerja telah mendapat pelatihan yang sesuai </label> -->
                      <label for="Preexect1" class="ml-2">
                        {{ $t("Preexect1_cowp") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect2"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect2" class="ml-2"> Seluruh langkah telah dipertimbangkan untuk mengeliminasi adanya risiko (pertimbangkan alternatif lainnya) </label> -->
                      <label for="Preexect2" class="ml-2">
                        {{ $t("Preexect2_cowp") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect3"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect3" class="ml-2"> Hierarki pengendalian telah dipersiapkan untuk memastikan bahwa risiko paling rendah yang telah diambil</label> -->
                      <label for="Preexect3" class="ml-2">
                        {{ $t("Preexect3_cowp") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect4"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect4" class="ml-2"> Personil yang melakukan pekerjaan telah diinduksi, dilatih, dan berkompeten</label> -->
                      <label for="Preexect4" class="ml-2">
                        {{ $t("Preexect4_cowp") }}
                      </label>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      this.permitCategory == this.$PERMIT_CATEGORY.EXCP
                    "
                  >
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect1"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect1" class="ml-2"> Seluruh langkah telah dipertimbangkan untuk mengeliminasi risiko selama pekerjaan penggalian berlangsung. </label> -->
                      <label for="Preexect1" class="ml-2">
                        {{ $t("Preexect1_excp") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect2"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect2" class="ml-2"> Hierarki pengendalian telah dipersiapkan untuk memastikan risiko paling rendah telah diambil. </label> -->
                      <label for="Preexect2" class="ml-2">
                        {{ $t("Preexect2_excp") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect3"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect3" class="ml-2"> Personil yang melakukan pekerjaan telah diinduksi, dilatih, dan berkompeten melakukan penggalian dan menggunakan tindakan pengendalian yang sesuai</label> -->
                      <label for="Preexect3" class="ml-2">
                        {{ $t("Preexect3_excp") }}
                      </label>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      this.permitCategory == this.$PERMIT_CATEGORY.HLWP
                    "
                  >
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect1"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect1" class="ml-2"> Semua langkah telah dipertimbangkan untuk mengeliminasi risiko aktivitas pengangkatan, ≥ 2 Ton. </label> -->
                      <label for="Preexect1" class="ml-2">
                        {{ $t("Preexect1_hlwp") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect2"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect2" class="ml-2"> Hierarki pengendalian telah dipersiapkan untuk memastikan risiko paling kecil yang akan diambil. </label> -->
                      <label for="Preexect2" class="ml-2">
                        {{ $t("Preexect2_hlwp") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect3"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect3" class="ml-2"> Personil yang melakukan pekerjaan telah diinduksi, dilatih, dan berkompeten dalam aktivitas pengangkatan, serta tindakan pengendaliannya telah disiapkan .(mis. Rigging, slinging, operator crane, dll)</label> -->
                      <label for="Preexect3" class="ml-2">
                        {{ $t("Preexect3_hlwp") }}
                      </label>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      this.permitCategory == this.$PERMIT_CATEGORY.LIVE
                    "
                  >
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect1"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect1" class="ml-2"> Ruang kerja cukup dan juga rute jalan tersedia.</label> -->
                      <label for="Preexect1" class="ml-2">
                        {{ $t("Preexect1_live") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect2"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect2" class="ml-2"> Komunikasi (radio/HT) tersedia, berfungsi dengan baik dan baterai cadangan yang terisi penuh tersedia.</label> -->
                      <label for="Preexect2" class="ml-2">
                        {{ $t("Preexect2_live") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect3"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect3" class="ml-2"> Area kerja memiliki pencahayaan yang cukup (sekitar 1000LUX).</label> -->
                      <label for="Preexect3" class="ml-2">
                        {{ $t("Preexect3_live") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect4"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect4" class="ml-2">Tanda Peringatan dan barikade untuk control di area tertentu tersedia dilokasi.</label> -->
                      <label for="Preexect4" class="ml-2">
                        {{ $t("Preexect4_live") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect5"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect5" class="ml-2">Peralatan Isolasi dengan voltage rated tersedia.</label> -->
                      <label for="Preexect5" class="ml-2">
                        {{ $t("Preexect5_live") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect6"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect6" class="ml-2">Tangga portable kering dengan anak tangga nonconductive tersedia.</label> -->
                      <label for="Preexect6" class="ml-2">
                        {{ $t("Preexect6_live") }}
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect7"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <!-- <label for="Preexect7" class="ml-2">Peralatan uji diarea kerja sesuai dengan tegangan kerja dan sesuai dengan standart proteksi keselamatan (contoh ohms/amp memiliki fuse).</label> -->
                      <label for="Preexect7" class="ml-2">
                        {{ $t("Preexect7_live") }}
                      </label>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      this.permitCategory == this.$PERMIT_CATEGORY.HOWP
                    "
                  >
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect1"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect1" class="ml-2">
                        Semua langkah telah dipertimbangkan untuk mengeliminasi
                        risiko aktivitas pengangkatan, ≥ 2 Ton.
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect2"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect2" class="ml-2">
                        Hierarki pengendalian telah dipersiapkan untuk
                        memastikan risiko paling kecil yang akan diambil.
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect3"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect3" class="ml-2">
                        Personil yang melakukan pekerjaan telah diinduksi,
                        dilatih, dan berkompeten dalam aktivitas pengangkatan,
                        serta tindakan pengendaliannya telah disiapkan .(mis.
                        Rigging, slinging, operator crane, dll)</label
                      >
                    </div>
                  </div>
                  <div
                    v-else-if="
                      this.permitCategory == this.$PERMIT_CATEGORY.CSEP
                    "
                  >
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect1"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect1" class="ml-2">
                        Semua langkah telah dipertimbangkan untuk mengeliminasi
                        risiko aktivitas pengangkatan, ≥ 2 Ton.
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect2"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect2" class="ml-2">
                        Hierarki pengendalian telah dipersiapkan untuk
                        memastikan risiko paling kecil yang akan diambil.
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect3"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect3" class="ml-2">
                        Personil yang melakukan pekerjaan telah diinduksi,
                        dilatih, dan berkompeten dalam aktivitas pengangkatan,
                        serta tindakan pengendaliannya telah disiapkan .(mis.
                        Rigging, slinging, operator crane, dll)</label
                      >
                    </div>
                  </div>
                  <div
                    v-else-if="
                      this.permitCategory == this.$PERMIT_CATEGORY.LOTO
                    "
                  >
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect1"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect1" class="ml-2">
                        Semua langkah telah dipertimbangkan untuk mengeliminasi
                        risiko aktivitas pengangkatan, ≥ 2 Ton.
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect2"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect2" class="ml-2">
                        Hierarki pengendalian telah dipersiapkan untuk
                        memastikan risiko paling kecil yang akan diambil.
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect3"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect3" class="ml-2">
                        Personil yang melakukan pekerjaan telah diinduksi,
                        dilatih, dan berkompeten dalam aktivitas pengangkatan,
                        serta tindakan pengendaliannya telah disiapkan .(mis.
                        Rigging, slinging, operator crane, dll)</label
                      >
                    </div>
                  </div>
                  <div
                    v-else-if="
                      this.permitCategory == this.$PERMIT_CATEGORY.WAHP
                    "
                  >
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect1"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect1" class="ml-2">
                        Semua langkah telah dipertimbangkan untuk mengeliminasi
                        risiko aktivitas pengangkatan, ≥ 2 Ton.
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect2"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect2" class="ml-2">
                        Hierarki pengendalian telah dipersiapkan untuk
                        memastikan risiko paling kecil yang akan diambil.
                      </label>
                    </div>
                    <div class="flex align-items-center mt-4">
                      <YNCheckbox
                        v-model="header.Preexect3"
                        :disabled="
                          !canEdit ||
                          (this.mode == this.$FORM_MODE_EDIT &&
                            header.Status == 'REJ')
                        "
                        v-if="header"
                        :binary="true"
                      />
                      <label for="Preexect3" class="ml-2">
                        Personil yang melakukan pekerjaan telah diinduksi,
                        dilatih, dan berkompeten dalam aktivitas pengangkatan,
                        serta tindakan pengendaliannya telah disiapkan .(mis.
                        Rigging, slinging, operator crane, dll)</label
                      >
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel
                header="Area"
                v-if="
                  this.isGeneralFull == true &&
                  this.permitCategory == this.$PERMIT_CATEGORY.EXCP
                "
                :key="this.$TAB_SECTION.AREA"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Area</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirm($event)"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <!-- <Area :dataArray="header" :dataModel="dataModelArea" :mode="mode" v-if="header"
                                            :header="header" /> -->
                <div class="col-12">
                  <Message severity="info" :closable="false">
                    <table>
                      <tr>
                        <td><b>Info!</b></td>
                      </tr>
                      <tr>
                        <td>
                          The work area must be worked on, leveling, cutting and
                          excavating.
                        </td>
                      </tr>
                    </table>
                  </Message>
                </div>
                <div class="grid">
                  <div class="col-6">
                    <FormField
                      :labelName="$t('area_length')"
                      fieldName="AreaLength"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputNumber
                        name="AreaLength"
                        v-model="header.AreaLength"
                        v-if="header"
                        :disabled="!canEdit"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('area_width')"
                      fieldName="AreaWidth"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputNumber
                        name="AreaWidth"
                        v-model="header.AreaWidth"
                        v-if="header"
                        :disabled="!canEdit"
                      />
                    </FormField>
                  </div>
                  <div class="col-6">
                    <FormField
                      :labelName="$t('area_depth')"
                      fieldName="AreaDepth"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputNumber
                        name="AreaDepth"
                        v-model="header.AreaDepth"
                        v-if="header"
                        :disabled="!canEdit"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('area_volume')"
                      fieldName="AreaVolume"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputNumber
                        name="AreaVolume"
                        v-model="header.AreaVolume"
                        v-if="header"
                        :disabled="!canEdit"
                      />
                    </FormField>
                  </div>
                </div>
                <div class="col-12">
                  <div class="flex align-items-center mt-4">
                    <YNCheckbox
                      v-model="header.Backfill"
                      :disabled="!canEdit"
                      v-if="header"
                      :binary="true"
                    />
                    <label for="Backfill" class="ml-2"
                      >{{ $t("area1") }}
                    </label>
                  </div>
                  <div class="flex align-items-center mt-4">
                    <YNCheckbox
                      v-model="header.PersonilInside"
                      :disabled="!canEdit"
                      v-if="header"
                      :binary="true"
                    />
                    <label for="PersonilInside" class="ml-2">
                      {{ $t("area2") }}
                    </label>
                  </div>

                  <div
                    class="flex align-items-center mt-4"
                    v-if="header && header.PersonilInside == 'Y'"
                  >
                    <label for="ProtectionSystem" class="col-2">
                      {{ $t("area3") }}
                    </label>
                    <CustomSelect
                      v-model="header.EeFireExtiguisherType"
                      :url="$API_URL + 'list/lookup'"
                      :minLength="0"
                      :filter="true"
                      :disabled="!canEdit"
                      :params="{ group: 'AREA_PROTECTION', allow_all: false }"
                    />
                  </div>

                  <div class="flex align-items-center mt-4">
                    <YNCheckbox
                      v-model="header.More6"
                      :disabled="!canEdit"
                      v-if="header"
                      :binary="true"
                    />
                    <label for="More6" class="ml-2"
                      >{{ $t("area4") }} <br />
                      <small>a). {{ $t("area4_a") }} </small><br />
                      <small>b). {{ $t("area4_b") }} </small>
                    </label>
                  </div>
                  <div class="flex align-items-center mt-4">
                    <YNCheckbox
                      v-model="header.UtilityFacility"
                      :disabled="!canEdit"
                      v-if="header"
                      :binary="true"
                    />
                    <label for="UtilityFacility" class="ml-2">
                      {{ $t("area5") }} <br />
                      <small>a). {{ $t("area5_a") }} </small><br />
                      <small>b). {{ $t("area5_b") }} </small><br />
                      <small>c). {{ $t("area5_c") }}</small>
                    </label>
                  </div>
                </div>
              </TabPanel>
              <TabPanel
                header="Risk"
                v-if="
                  this.isGeneralFull == true &&
                  this.permitCategory != this.$PERMIT_CATEGORY.CSEP &&
                  this.permitCategory != this.$PERMIT_CATEGORY.LIVE
                "
                :key="this.$TAB_SECTION.RISK"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Risk</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'RISK')"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template> </Toolbar
                ><br />

                <Risk
                  :dataArray="header.PermitRiskAsseses"
                  :dataModel="dataModelRisk"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel
                header="Supervision"
                v-if="this.isGeneralFull == true"
                :key="this.$TAB_SECTION.SPV"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Supervision</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'SPV')"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <Supervision
                  :dataArray="header.PermitSupervisions"
                  :dataModel="dataModelSupervision"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel
                header="Tools"
                v-if="this.isGeneralFull == true"
                :key="this.$TAB_SECTION.TOOLS"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Tools</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'TOOLS')"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <Tools
                  :dataArray="header.PermitToolsDetail"
                  :dataModel="dataModelTools"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel
                header="SOP"
                v-if="this.isGeneralFull == true"
                :key="this.$TAB_SECTION.SOP"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">SOP</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'SOP')"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <br />

                <Sop
                  :dataArray="header.PermitSopss"
                  :isGeneralFull="dataModelSop"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel
                header="Emergency"
                v-if="this.isGeneralFull == true"
                :key="this.$TAB_SECTION.EMERGENCY"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Emergency</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirm($event)"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <!-- <Emergency :dataArray="header" :dataModel="dataModelEmegergency" :mode="mode" v-if="header"
                                            :header="header" /> -->
                <div class="grid">
                  <div class="col-6">
                    <div class="flex align-items-center mt-4 mb-4">
                      <YNCheckbox
                        v-model="header.PermitEmergencyPlan"
                        :disabled="!canEdit"
                        v-if="header"
                        :binary="true"
                      />
                      <label for="PermitEmergencyPlan" class="ml-2">{{
                        $t("emergency1")
                      }}</label>
                    </div>
                    <FormField
                      :labelName="$t('emergecy_desc')"
                      fieldName="PermitEmergencyPlanDesc"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="PermitEmergencyPlanDesc"
                        v-model="header.PermitEmergencyPlanDesc"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit"
                      />
                    </FormField>
                  </div>
                  <div class="col-6">
                    <div class="flex align-items-center mt-4 mb-4">
                      <YNCheckbox
                        v-model="header.PermitFireAccess"
                        :disabled="!canEdit"
                        v-if="header"
                        :binary="true"
                      />
                      <label for="PermitFireAccess" class="ml-2">{{
                        $t("emergency2")
                      }}</label>
                    </div>
                    <FormField
                      :labelName="$t('emer_firefighter')"
                      fieldName="PermitEmergencyFirefighter"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="PermitEmergencyFirefighter"
                        v-model="header.PermitEmergencyFirefighter"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit"
                      />
                    </FormField>

                    <FormField
                      :labelName="$t('emergecy_pic')"
                      fieldName="PermitEmergencyResponsePic"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="PermitEmergencyResponsePic"
                        v-model="header.PermitEmergencyResponsePic"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit"
                      />
                    </FormField>

                    <FormField
                      :labelName="$t('emergecy_contact')"
                      fieldName="PermitEmergencyResponseContact"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="PermitEmergencyResponseContact"
                        v-model="header.PermitEmergencyResponseContact"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit"
                      />
                    </FormField>
                  </div>
                </div>
              </TabPanel>
              <TabPanel
                header="Close"
                v-if="this.isGeneralFull == true"
                :key="this.$TAB_SECTION.CLOSEV1"
              >
                <!-- <Close :dataArray="header" :dataModel="dataModelClose" :mode="mode" v-if="header"
                                            :header="header" /> -->
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Close</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirm($event)"
                      v-if="
                        (mode == this.$FORM_MODE_EDIT &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          (this.permitStatus == 'REJ' ||
                            this.permitStatus == 'OPN')) ||
                        (mode == this.$FORM_MODE_VIEW &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          this.permitStatus == 'PRG')
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <div class="col-12">
                  <Message severity="info" :closable="false">
                    <table>
                      <tr>
                        <td><b>Info!</b></td>
                      </tr>
                      <tr>
                        <td>{{ $t("closing_info1") }}</td>
                      </tr>
                      <tr>
                        <td>
                          <small>{{ $t("closing_info2") }}</small>
                        </td>
                      </tr>
                    </table>
                  </Message>
                </div>
                <div class="grid">
                  <div class="col-6">
                    <div class="flex flex-column gap-2 mt-4">
                      <CustomFileUpload
                        :fileModels="imgCloseModel"
                        :multiple="false"
                        :showUploadButton="false"
                        :showCancelButton="false"
                        :customUpload="false"
                        :maxFileSize="5000000"
                        accept="image/png,/image/jpg,image/jpeg,application/pdf"
                        @select="onFileSelectImgClose"
                        :disabled="this.permitStatus != 'PRG'"
                        @remove="onFileRemoveImgClose"
                      />
                      <CustomFileUpload
                        :fileModels="this.viewFileCloses"
                        :multiple="false"
                        :showUploadButton="false"
                        :showCancelButton="false"
                        :customUpload="false"
                        @select="onFileSelectImgClose"
                        @remove="onFileRemoveImgClose"
                        :viewOnly="true"
                        :showHeader="false"
                        @download="onDownloadFile"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <Fieldset legend="Permit Extend" class="mb-4">
                      <div class="flex align-items-center mt-4">
                        <YNCheckbox
                          v-model="header.IsExtend"
                          :disabled="
                            this.permitStatus != 'PRG' ||
                            (this.permitStatus == 'PRG' &&
                              this.Extended == 'Y') ||
                            this.permitUser != this.userName
                          "
                          v-if="header"
                          :binary="true"
                        />
                        <label for="IsExtend" class="ml-2"
                          >{{ $t("extend_info") }}
                        </label>
                      </div>
                      <div v-if="header && header.IsExtend == 'Y'" class="mt-4">
                        <FormField
                          :labelName="$t('ExtStartTime')"
                          fieldName="ExtStartTime"
                          v-model="header"
                          fieldClass="col-6"
                          labelClass="col-4"
                        >
                          <div
                            class="field grid"
                            style="margin-bottom: 0 !important"
                          >
                            <div class="col-5">
                              <DatePicker
                                id="calendar-timeonly"
                                :class="{
                                  'p-invalid':
                                    submitted && !header.ExtStartTime,
                                }"
                                momentFormat="HH:mm"
                                v-if="header"
                                v-model="header.ExtStartTime"
                                timeOnly
                                :disabled="
                                  this.permitStatus != 'PRG' ||
                                  this.Extended == 'Y' ||
                                  this.permitUser != this.userName
                                "
                              />
                              <small
                                v-if="
                                  header &&
                                  !header.ExtStartTime &&
                                  submitted &&
                                  this.permitStatus == 'PRG' &&
                                  mode == this.$FORM_MODE_VIEW &&
                                  header.IsExtend == 'Y'
                                "
                                class="p-error"
                                >{{
                                  $t("is_required").replace(
                                    "Value",
                                    $t("ext_start_time")
                                  )
                                }}
                              </small>
                            </div>
                            <label for="FinishTime" class="col-2">Finish</label>
                            <div class="col-5">
                              <DatePicker
                                id="calendar-timeonly"
                                momentFormat="HH:mm"
                                :class="{
                                  'p-invalid':
                                    submitted && !header.ExtFinsihTime,
                                }"
                                v-if="header"
                                v-model="header.ExtFinsihTime"
                                timeOnly
                                :disabled="
                                  this.permitStatus != 'PRG' ||
                                  this.Extended == 'Y'
                                "
                              />
                              <small
                                v-if="
                                  header &&
                                  !header.ExtFinsihTime &&
                                  submitted &&
                                  this.permitStatus == 'PRG' &&
                                  mode == this.$FORM_MODE_VIEW &&
                                  header.IsExtend == 'Y'
                                "
                                class="p-error"
                                >{{
                                  $t("is_required").replace(
                                    "Value",
                                    $t("ext_finish_time")
                                  )
                                }}
                              </small>
                            </div>
                          </div>
                        </FormField>
                        <FormField
                          :labelName="$t('ExtDesc')"
                          fieldName="ExtDesc"
                          v-model="header"
                          fieldClass="col-6"
                          labelClass="col-4"
                        >
                          <InputText
                            name="ExtDesc"
                            v-model="header.ExtDesc"
                            type="text"
                            :class="{
                              'p-invalid': submitted && !header.ExtDesc,
                            }"
                            v-if="header"
                            :disabled="
                              this.permitStatus != 'PRG' || this.Extended == 'Y'
                            "
                          />
                          <small
                            v-if="
                              header &&
                              !header.ExtDesc &&
                              submitted &&
                              this.permitStatus == 'PRG' &&
                              mode == this.$FORM_MODE_VIEW &&
                              header.IsExtend == 'Y'
                            "
                            class="p-error"
                            >{{
                              $t("is_required").replace("Value", $t("ext_desc"))
                            }}
                          </small>
                        </FormField>
                      </div>
                    </Fieldset>
                  </div>
                </div>
              </TabPanel>
            </TabView>
          </div>
          <div v-else-if="this.permitVersion == 2">
            <div class="col-12">
              <div
                v-if="
                  this.distanceMi != null && this.mode == this.$FORM_MODE_VERIFY
                "
              >
                <Message
                  severity="info"
                  icon="pi pi-send"
                  :closable="false"
                  v-if="this.distanceMi < this.radius"
                >
                  <table>
                    <tr>
                      <td><b> In Range :</b></td>
                      <td>
                        <b>{{ this.distanceMi }} m</b>
                      </td>
                    </tr>
                  </table>
                </Message>
                <Message
                  severity="error"
                  icon="pi pi-send"
                  :closable="false"
                  v-else-if="this.distanceMi > this.radius"
                >
                  <table>
                    <tr>
                      <td><b> Out Range :</b></td>
                      <td>
                        <b>{{ this.distanceMi }} m</b>
                      </td>
                    </tr>
                  </table> </Message
                ><br />
              </div>
              <Message severity="warn" icon="pi pi-send" :closable="false">
                <table>
                  <tr>
                    <td><b> Permit Checklist :</b></td>
                    <td>
                      <b
                        >{{
                          this.overallPrecentage == null
                            ? 0
                            : this.overallPrecentage
                        }}%</b
                      >
                    </td>
                  </tr>
                </table>
              </Message>
            </div>

            <TabView ref="tabViewRef" @tab-change="onTabChange">
              <TabPanel header="General" :key="this.$TAB_SECTION.GNR">
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">General</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirm($event)"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <div class="col-12">
                  <Message severity="info" :closable="false">
                    <table>
                      <tr>
                        <td><b>Caution!</b></td>
                      </tr>
                      <tr>
                        <td>
                          General Data Cannot Be Revised, Please Double Check
                          Your Entries.
                        </td>
                      </tr>
                    </table>
                  </Message>
                </div>
                <div class="grid">
                  <div class="col-6">
                    <FormField
                      :labelName="$t('title')"
                      fieldName="Title"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <InputText
                        name="Title"
                        :class="{ 'p-invalid': submitted && !header.Title }"
                        v-model="header.Title"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit || this.isGeneralFull == true"
                      />
                      <small
                        v-if="
                          header &&
                          !header.Title &&
                          submitted &&
                          mode != this.$FORM_MODE_DELETE
                        "
                        class="p-error"
                        >{{ $t("is_required").replace("Value", $t("title")) }}
                      </small>
                    </FormField>
                    <FormField
                      :labelName="$t('date')"
                      fieldName="PermitDate"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <DatePicker
                        v-model="header.PermitDate"
                        :class="{
                          'p-invalid': submitted && !header.PermitDate,
                        }"
                        dateFormat="dd/mm/yyyy"
                        inputMask="99/99/9999"
                        momentFormat="DD/MM/YYYY"
                        class="p-inputtext-sm"
                        v-if="header"
                        :minDate="header.workStartDate"
                        :disabled="!canEdit || this.isGeneralFull == true"
                      />
                      <small
                        v-if="
                          header &&
                          !header.PermitDate &&
                          submitted &&
                          mode != this.$FORM_MODE_DELETE
                        "
                        class="p-error"
                        >{{ $t("is_required").replace("Value", $t("date")) }}
                      </small>
                    </FormField>
                    <FormField
                      :labelName="$t('start_time')"
                      fieldName="StartTime"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <div
                        class="field grid"
                        style="margin-bottom: 0 !important"
                      >
                        <div class="col-5">
                          <DatePicker
                            id="calendar-timeonly"
                            :class="{
                              'p-invalid': submitted && !header.StartTime,
                            }"
                            momentFormat="HH:mm"
                            v-if="header"
                            v-model="header.StartTime"
                            timeOnly
                            :disabled="!canEdit"
                          />
                          <small
                            v-if="
                              header &&
                              !header.StartTime &&
                              submitted &&
                              mode != this.$FORM_MODE_DELETE
                            "
                            class="p-error"
                            >{{
                              $t("is_required").replace(
                                "Value",
                                $t("start_time")
                              )
                            }}
                          </small>
                        </div>
                        <label for="FinishTime" class="col-2">Finish</label>
                        <div class="col-5">
                          <DatePicker
                            id="calendar-timeonly"
                            :class="{
                              'p-invalid': submitted && !header.FinishTime,
                            }"
                            momentFormat="HH:mm"
                            v-if="header"
                            v-model="header.FinishTime"
                            timeOnly
                            :disabled="!canEdit"
                          />
                          <small
                            v-if="
                              header &&
                              !header.FinishTime &&
                              submitted &&
                              mode != this.$FORM_MODE_DELETE
                            "
                            class="p-error"
                            >{{ $t("is_required").replace("Value", "Finish") }}
                          </small>
                        </div>
                      </div>
                    </FormField>
                    <FormField
                      :labelName="$t('involved_area')"
                      fieldName="RelatedArea"
                      v-model="header"
                      labelClass="col-4"
                      fieldClass="col-6 md-6"
                    >
                      <CustomSelect
                        v-model="header.RelatedArea"
                        v-if="header"
                        :url="this.$API_URL + 'list/department'"
                        :minLength="0"
                        :filter="true"
                        :params="{ companyCode: header.CompanyCode }"
                        :disabled="!canEdit || this.isGeneralFull == true"
                        @change="changeDept($event)"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('actual_work')"
                      fieldName="Description"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                      :required="true"
                    >
                      <InputText
                        name="Description"
                        :class="{
                          'p-invalid': submitted && !header.Description,
                        }"
                        v-model="header.Description"
                        type="text"
                        v-if="header"
                        :disabled="!canEdit || this.isGeneralFull == true"
                      />
                      <small
                        v-if="
                          header &&
                          !header.Description &&
                          submitted &&
                          mode != this.$FORM_MODE_DELETE
                        "
                        class="p-error"
                        >{{
                          $t("is_required").replace("Value", $t("actual_work"))
                        }}
                      </small>
                    </FormField>

                    <div
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.HOWP"
                    >
                      <div class="grid">
                        <div class="col-4">
                          <div class="flex align-items-center mt-4">
                            <YNCheckbox
                              v-model="header.WorkSoldering"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="WorkSoldering" class="ml-2">
                              Soldering
                            </label>
                          </div>
                          <div class="flex align-items-center mt-4">
                            <YNCheckbox
                              v-model="header.WorkBrazing"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="WorkBrazing" class="ml-2">
                              Brazzing
                            </label>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="flex align-items-center mt-4">
                            <YNCheckbox
                              v-model="header.WorkWelding"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="WorkWelding" class="ml-2">
                              Welding</label
                            >
                          </div>
                          <div class="flex align-items-center mt-4">
                            <YNCheckbox
                              v-model="header.WorkTorchCutting"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="WorkTorchCutting" class="ml-2">
                              Torch Cutting</label
                            >
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="flex align-items-center mt-4">
                            <YNCheckbox
                              v-model="header.WorkGrinding"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="WorkGrinding" class="ml-2">
                              Grinding
                            </label>
                          </div>
                          <div class="flex align-items-center mt-4">
                            <YNCheckbox
                              v-model="header.WorkOthers"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="WorkOthers" class="ml-2"> Other </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.CSEP"
                    >
                      <FormField
                        :labelName="$t('no_of_entrant')"
                        fieldName="NoOfEntrant"
                        v-model="header"
                        fieldClass="col-6"
                        labelClass="col-4"
                        :required="true"
                      >
                        <InputNumber
                          name="NoOfEntrant"
                          :class="{
                            'p-invalid': submitted && !header.NoOfEntrant,
                          }"
                          v-model="header.NoOfEntrant"
                          :useGrouping="false"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                        <small
                          v-if="
                            header &&
                            !header.NoOfEntrant &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                          "
                          class="p-error"
                          >{{
                            $t("is_required").replace(
                              "Value",
                              $t("no_of_entrant")
                            )
                          }}
                        </small>
                      </FormField>
                      <FormField
                        :labelName="$t('content_to_drain')"
                        fieldName="ContentToDrain"
                        v-model="header"
                        fieldClass="col-6"
                        labelClass="col-4"
                      >
                        <InputText
                          name="ContentToDrain"
                          :class="{
                            'p-invalid': submitted && !header.ContentToDrain,
                          }"
                          v-model="header.ContentToDrain"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                        <small
                          v-if="
                            header &&
                            !header.ContentToDrain &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                          "
                          class="p-error"
                          >{{
                            $t("is_required").replace(
                              "Value",
                              $t("content_to_drain")
                            )
                          }}
                        </small>
                      </FormField>
                      <FormField
                        :labelName="$t('req_entry_time')"
                        fieldName="ReqEntryTime"
                        v-model="header"
                        fieldClass="col-6"
                        labelClass="col-4"
                        :required="true"
                      >
                        <div
                          class="field grid"
                          style="margin-bottom: 0 !important"
                        >
                          <div class="col-5">
                            <DatePicker
                              id="calendar-timeonly"
                              :class="{
                                'p-invalid': submitted && !header.ReqEntryTime,
                              }"
                              momentFormat="HH:mm"
                              v-if="header"
                              v-model="header.ReqEntryTime"
                              timeOnly
                              :disabled="!canEdit"
                            />
                            <small
                              v-if="
                                header &&
                                !header.ReqEntryTime &&
                                submitted &&
                                mode != this.$FORM_MODE_DELETE
                              "
                              class="p-error"
                              >{{
                                $t("is_required").replace(
                                  "Value",
                                  $t("req_entry_time")
                                )
                              }}
                            </small>
                          </div>
                          <label for="ReqLeaveTime" class="col-2">Finish</label>
                          <div class="col-5">
                            <DatePicker
                              id="calendar-timeonly"
                              :class="{
                                'p-invalid': submitted && !header.ReqLeaveTime,
                              }"
                              momentFormat="HH:mm"
                              v-if="header"
                              v-model="header.ReqLeaveTime"
                              timeOnly
                              :disabled="!canEdit"
                            />
                            <small
                              v-if="
                                header &&
                                !header.ReqLeaveTime &&
                                submitted &&
                                mode != this.$FORM_MODE_DELETE
                              "
                              class="p-error"
                              >{{
                                $t("is_required").replace("Value", "Finish")
                              }}
                            </small>
                          </div>
                        </div>
                      </FormField>
                    </div>
                  </div>
                  <div class="col-6">
                    <FormField
                      :labelName="$t('permit_number')"
                      fieldName="PermitNumber"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="PermitNumber"
                        v-model="header.PermitNumber"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('status')"
                      fieldName="Status"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="Jsea"
                        v-model="header.Status"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('category')"
                      fieldName="Category"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="Category"
                        v-model="header.Category"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('critical')"
                      fieldName="Critical"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="Critical"
                        v-model="header.Critical"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('created_by')"
                      fieldName="CreatedBy"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="CreatedBy"
                        v-model="header.CreatedBy"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('company_owning')"
                      fieldName="CompanyCode"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="CompanyCode"
                        v-model="header.CompanyCode"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('area_name')"
                      fieldName="UserDeptname"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="UserDeptname"
                        v-model="header.UserDeptname"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('department')"
                      fieldName="AreaName"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="AreaName"
                        v-model="header.AreaName"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('sub_area_name')"
                      fieldName="SubAreaName"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="SubAreaName"
                        v-model="header.SubAreaName"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                    <FormField
                      :labelName="$t('spesific_area')"
                      fieldName="SpesificArea"
                      v-model="header"
                      v-if="!isCreate"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="SpesificArea"
                        v-model="header.SpesificArea"
                        type="text"
                        v-if="header"
                        :disabled="true"
                      />
                    </FormField>
                  </div>
                </div>
                <div
                  class="col-12 mt-4"
                  v-if="this.mode != this.$FORM_MODE_CREATE"
                >
                  <TabView>
                    <TabPanel :header="$t('release_approval')">
                      <ChangeHistory
                        v-if="this.header"
                        :modelValue="this.dataModelRelease"
                        :dataRequestLog="this.dataRelease"
                        :mode="this.mode"
                      ></ChangeHistory>
                    </TabPanel>
                    <!-- <TabPanel :header="$t('log_history')">
                      <ChangeHistory
                        v-if="this.header"
                        :modelValue="this.dataModelPermitLogs"
                        :dataRequestLog="this.dataPermitLogs"
                        :mode="this.mode"
                      ></ChangeHistory>
                    </TabPanel> -->
                  </TabView>
                </div>
              </TabPanel>
              <TabPanel header="Supervision" :key="this.$TAB_SECTION.SPV">
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Supervision</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'SPV')"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <Supervision
                  :dataArray="header.PermitSupervisions"
                  :dataModel="dataModelSupervision"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel header="Worker" :key="this.$TAB_SECTION.WORKER">
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Worker</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-check-circle"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'WORKER')"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <Worker
                  :dataArray="header.PermitWorkers"
                  :dataModel="dataModelPermitWorker"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel
                header="AGT Person"
                v-if="
                  (this.permitCategory == this.$PERMIT_CATEGORY.HOWP ||
                    this.permitCategory == this.$PERMIT_CATEGORY.CSEP) &&
                  this.header.useAgt == true
                "
                :key="this.$TAB_SECTION.AGT"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">AGT Person</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-check-circle"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'AGT')"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N'
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <Agt
                  :dataArray="header.AgtPerson"
                  :dataModel="dataModelAgtPerson"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel
                header="Entrance Record"
                v-if="
                  this.header.isWorkerExist == 'Y' &&
                  this.permitCategory == this.$PERMIT_CATEGORY.CSEP
                "
                :key="this.$TAB_SECTION.ENTRANCE"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Entrance Record</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'ENTRANCE')"
                      v-if="
                        (mode == this.$FORM_MODE_EDIT &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          (this.permitStatus == 'REJ' ||
                            this.permitStatus == 'OPN')) ||
                        (mode == this.$FORM_MODE_VIEW &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          this.permitStatus == 'PRG')
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <Entrance
                  :dataArray="header.Entrances"
                  :dataModel="dataModelEntrance"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel header="Tools" :key="this.$TAB_SECTION.TOOLS">
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Tools</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'TOOLS')"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <Tools
                  :dataArray="header.PermitToolsDetail"
                  :dataModel="dataModelTools"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel
                header="Preparation & Precautions"
                :key="this.$TAB_SECTION.PREPRE"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold"
                      >Preparation & Precautions</span
                    >
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirm($event)"
                      v-if="
                        (mode == this.$FORM_MODE_EDIT &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          (this.permitStatus == 'REJ' ||
                            this.permitStatus == 'OPN')) ||
                        (this.header.useAgt == true &&
                          this.header.amIAgt == true &&
                          this.permitDelete == 'N' &&
                          this.mode == this.$FORM_MODE_VIEW &&
                          (this.permitStatus == 'REJ' ||
                            this.permitStatus == 'OPN'))
                      "
                    />
                  </template>
                </Toolbar>
                <div class="grid">
                  <div class="col-6">
                    <Fieldset
                      legend="Job Safety & Environmental Analysis (JSEA)"
                      class="mb-4"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.JseaReviewedAndApproved"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="JseaReviewedAndApproved" class="ml-2">
                          {{ $t("JseaReviewedAndApproved") }}
                          <span style="color: red">*</span>.<br />
                          Reference Document :
                          <b>{{ header.JseaPermit }}</b></label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.ControlMeasuresImplemented"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="ControlMeasuresImplemented" class="ml-2"
                          >{{ $t("ControlMeasuresImplemented") }}
                          <span style="color: red">*</span></label
                        >
                      </div>
                      <div class="flex align-items-center mt-2 mb-4">
                        <YNCheckbox
                          v-model="header.ChecklistReviewed"
                          :disabled="true"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="ChecklistReviewed" class="ml-2">
                          {{ $t("ChecklistReviewed") }}
                          <span style="color: red">*</span>
                        </label>
                      </div>
                      <Message severity="info" :closable="false">
                        <table>
                          <tr>
                            <td><b>Direction!</b></td>
                          </tr>
                          <tr>
                            <td>
                              High Risk Activity - Automatically checked when
                              all checklists verified.
                            </td>
                          </tr>
                        </table>
                      </Message>
                    </Fieldset>
                    <Fieldset
                      legend="Hazard Identification*"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.WAHP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi1" class="ml-2"> {{ $t("Hi1") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi2" class="ml-2"> {{ $t("Hi2") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi3" class="ml-2"> {{ $t("Hi3") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi4" class="ml-2"> {{ $t("Hi4") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi5" class="ml-2"> {{ $t("Hi5") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi6"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi6" class="ml-2"> {{ $t("Hi6") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi7"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi7" class="ml-2"> {{ $t("Hi7") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi8"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi8" class="ml-2"> {{ $t("Hi8") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi9"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi9" class="ml-2"> {{ $t("Hi9") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi10"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi10" class="ml-2"> {{ $t("Hi10") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi11"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi11" class="ml-2"> {{ $t("Hi11") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hi12"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hi12" class="ml-2"> {{ $t("Hi12") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="HiOther"
                          v-model="header.HiOther"
                          :placeholder="$t('HiOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Pre-Isolation Works Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.LOTO"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoLeft1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoLeft1" class="ml-2">
                          {{ $t("PreLotoLeft1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoLeft2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoLeft2" class="ml-2">{{
                          $t("PreLotoLeft2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoLeft3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoLeft3" class="ml-2">
                          {{ $t("PreLotoLeft3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoLeft4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoLeft4" class="ml-2">
                          {{ $t("PreLotoLeft4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoLeft5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoLeft5" class="ml-2">
                          {{ $t("PreLotoLeft5") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoLeft6"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoLeft6" class="ml-2">
                          {{ $t("PreLotoLeft6") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="PreLotoLeftOther"
                          v-model="header.PreLotoLeftOther"
                          :placeholder="$t('PreLotoLeftOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoRight1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoRight1" class="ml-2">
                          {{ $t("PreLotoRight1") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoRight2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoRight2" class="ml-2">
                          {{ $t("PreLotoRight2") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoRight3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoRight3" class="ml-2">
                          {{ $t("PreLotoRight3") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PreLotoRight4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PreLotoRight4" class="ml-2">
                          {{ $t("PreLotoRight4") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="PreLotoRightOther"
                          v-model="header.PreLotoRightOther"
                          :placeholder="$t('PreLotoRightOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Controls Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.LOTO"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq1" class="ml-2">
                          {{ $t("CtrReq1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq2" class="ml-2">{{
                          $t("CtrReq2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq3" class="ml-2">
                          {{ $t("CtrReq3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq4" class="ml-2">
                          {{ $t("CtrReq4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq5" class="ml-2">
                          {{ $t("CtrReq5") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq6"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq6" class="ml-2">
                          {{ $t("CtrReq6") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq7"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq7" class="ml-2">
                          {{ $t("CtrReq7") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq8"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq8" class="ml-2">
                          {{ $t("CtrReq8") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq9"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq9" class="ml-2">
                          {{ $t("CtrReq9") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq10"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq10" class="ml-2">
                          {{ $t("CtrReq10") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="CtrReqRef"
                          v-model="header.CtrReqRef"
                          :placeholder="$t('CtrReqRef')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq10"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq10" class="ml-2">
                          {{ $t("CtrReq10") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.CtrReq11"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="CtrReq11" class="ml-2">
                          {{ $t("CtrReq11") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="CtrReqOther"
                          v-model="header.CtrReqOther"
                          :placeholder="$t('CtrReqOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Harness Use*"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.WAHP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hu1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hu1" class="ml-2"> {{ $t("Hu1") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hu2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hu2" class="ml-2">{{ $t("Hu2") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Hu3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Hu3" class="ml-2"> {{ $t("Hu3") }} </label>
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Ladder Use"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.WAHP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Lu1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Lu1" class="ml-2"> {{ $t("Lu1") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Lu2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Lu2" class="ml-2">{{ $t("Lu2") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Lu3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Lu3" class="ml-2"> {{ $t("Lu3") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Lu4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Lu4" class="ml-2"> {{ $t("Lu4") }} </label>
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Crane – Man-cage “NON-Preferred Method”"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.WAHP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Crane1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Crane1" class="ml-2">
                          {{ $t("Crane1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Crane2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Crane2" class="ml-2">{{
                          $t("Crane2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Crane3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Crane3" class="ml-2">
                          {{ $t("Crane3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Crane4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Crane4" class="ml-2">
                          {{ $t("Crane4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="CraneLoad"
                          v-model="header.CraneLoad"
                          :placeholder="$t('CraneLoad')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Decontamination Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.CSEP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Decon1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Decon1" class="ml-2">
                          {{ $t("Decon1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Decon2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Decon2" class="ml-2">{{
                          $t("Decon2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Decon3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Decon13" class="ml-2">
                          {{ $t("Decon3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Decon4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Decon4" class="ml-2">
                          {{ $t("Decon4") }}
                        </label>
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Exposure to Other Contaminants (Refer to Sec. 8 of individual SDS)"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.CSEP"
                    >
                      <FormField
                        :labelName="$t('HazardSubsName')"
                        fieldName="HazardSubsName"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                      >
                        <InputText
                          name="HazardSubsName"
                          v-model="header.HazardSubsName"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('HazardSubsLimit')"
                        fieldName="HazardSubsLimit"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                      >
                        <InputNumber
                          name="HazardSubsLimit"
                          v-model="header.HazardSubsLimit"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </FormField>
                    </Fieldset>
                    <Fieldset
                      legend="Initial Gas & Atmospheric Testing Required"
                      v-if="
                        this.permitCategory == this.$PERMIT_CATEGORY.CSEP ||
                        this.permitCategory == this.$PERMIT_CATEGORY.HOWP
                      "
                      class="mb-4"
                    >
                      <Message
                        severity="warn"
                        :closable="false"
                        class="mb-4"
                        v-if="this.header.useAgt == true"
                      >
                        Initial Gas & Atmospheric Testing must be filled in by
                        AGT Person </Message
                      ><br />
                      <Message severity="info" :closable="false" class="mb-4">
                        <table>
                          <tr>
                            <td><b>Direction!</b></td>
                          </tr>
                          <tr>
                            <td>
                              Add character comma (.0) for zero value. Example:
                              "0.0"
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Number of "0" itself will be read by system as
                              empty value or checking not being performed
                            </td>
                          </tr>
                        </table>
                      </Message>
                      <FormField
                        :labelName="$t('Ostart')"
                        fieldName="Ostart"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6 mt-2"
                        labelClass="col-4 mt-2"
                        :required="true"
                      >
                        <InputNumber
                          name="Ostart"
                          v-model="header.Ostart"
                          type="text"
                          v-if="header"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode != this.$FORM_MODE_EDIT &&
                              this.header.Status == 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN')
                          "
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('Cstart')"
                        fieldName="Cstart"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                        :required="true"
                      >
                        <InputNumber
                          name="Cstart"
                          v-model="header.Cstart"
                          type="text"
                          v-if="header"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode != this.$FORM_MODE_EDIT &&
                              this.header.Status == 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN')
                          "
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('Hstart')"
                        fieldName="Hstart"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                        :required="true"
                      >
                        <InputNumber
                          name="Hstart"
                          v-model="header.Hstart"
                          v-if="header"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode == this.$FORM_MODE_EDIT &&
                              this.header.Status != 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN')
                          "
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('Lstart')"
                        fieldName="Lstart"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                        :required="true"
                      >
                        <InputNumber
                          name="Lstart"
                          v-model="header.Lstart"
                          v-if="header"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode != this.$FORM_MODE_EDIT &&
                              this.header.Status == 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN')
                          "
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('GasTesterCalibrationDate')"
                        fieldName="GasTesterCalibrationDate"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                        :required="true"
                      >
                        <DatePicker
                          v-model="header.GasTesterCalibrationDate"
                          dateFormat="dd/mm/yyyy"
                          inputMask="99/99/9999"
                          momentFormat="DD/MM/YYYY"
                          class="p-inputtext-sm"
                          v-if="header"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode != this.$FORM_MODE_EDIT &&
                              this.header.Status == 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN')
                          "
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('GasTesterModel')"
                        fieldName="GasTesterModel"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                        :required="true"
                      >
                        <InputText
                          name="GasTesterModel"
                          v-model="header.GasTesterModel"
                          v-if="header"
                          type="text"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode != this.$FORM_MODE_EDIT &&
                              this.header.Status == 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN')
                          "
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('GasTesterSerialNumber')"
                        fieldName="GasTesterSerialNumber"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                        :required="true"
                      >
                        <InputText
                          name="GasTesterSerialNumber"
                          v-model="header.GasTesterSerialNumber"
                          v-if="header"
                          type="text"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode != this.$FORM_MODE_EDIT &&
                              this.header.Status == 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN')
                          "
                        />
                      </FormField>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Continuously"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode != this.$FORM_MODE_EDIT &&
                              this.header.Status == 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN') ||
                            header.Periodically == 'Y'
                          "
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Continuously" class="ml-2">
                          {{ $t("continuously") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2 mb-2">
                        <YNCheckbox
                          v-model="header.Periodically"
                          :disabled="
                            (this.header.useAgt == false &&
                              this.mode != this.$FORM_MODE_EDIT &&
                              this.header.Status == 'OPN') ||
                            (this.header.useAgt == true &&
                              this.header.amIAgt == false &&
                              this.mode != this.$FORM_MODE_VIEW &&
                              this.header.Status == 'OPN') ||
                            header.Continuously == 'Y'
                          "
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Periodically" class="ml-2">
                          {{ $t("periodically") }}
                        </label>
                      </div>
                      <div v-if="header.Periodically == 'Y'">
                        <FormField
                          :labelName="$t('AtIntervalOf')"
                          fieldName="GasTeAtIntervalOfsterModel"
                          v-model="header"
                          v-if="!isCreate"
                          fieldClass="col-6"
                          labelClass="col-4"
                          :required="true"
                        >
                          <InputNumber
                            name="AtIntervalOf"
                            v-model="header.AtIntervalOf"
                            :min="1"
                            v-if="header"
                            :disabled="
                              (this.header.useAgt == false &&
                                this.mode != this.$FORM_MODE_EDIT &&
                                this.header.Status == 'OPN') ||
                              (this.header.useAgt == true &&
                                this.header.amIAgt == false &&
                                this.mode != this.$FORM_MODE_VIEW &&
                                this.header.Status == 'OPN')
                            "
                          />
                        </FormField>
                        <FormField
                          :labelName="$t('AfterBreaksOfMoreThan')"
                          fieldName="AfterBreaksOfMoreThan"
                          v-model="header"
                          v-if="!isCreate"
                          fieldClass="col-6"
                          labelClass="col-4"
                          :required="true"
                        >
                          <InputNumber
                            name="AfterBreaksOfMoreThan"
                            v-model="header.AfterBreaksOfMoreThan"
                            v-if="header"
                            :disabled="
                              (this.header.useAgt == false &&
                                this.mode != this.$FORM_MODE_EDIT &&
                                this.header.Status == 'OPN') ||
                              (this.header.useAgt == true &&
                                this.header.amIAgt == false &&
                                this.mode != this.$FORM_MODE_VIEW &&
                                this.header.Status == 'OPN')
                            "
                          />
                        </FormField>
                      </div>
                    </Fieldset>
                  </div>
                  <div class="col-6">
                    <Fieldset
                      legend="Energy Isolation Points Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.LOTO"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointElc1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointElc1" class="ml-2">
                          {{ $t("PointElc1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointElc2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointElc2" class="ml-2">{{
                          $t("PointElc2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointElc3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointElc3" class="ml-2">
                          {{ $t("PointElc3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointElc4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointElc4" class="ml-2">
                          {{ $t("PointElc4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="PointElcOther"
                          v-model="header.PointElcOther"
                          :placeholder="$t('PointElcOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>

                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointMec1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointMec1" class="ml-2">
                          {{ $t("PointMec1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointMec2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointElc2" class="ml-2">{{
                          $t("PointMec2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointMec3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointMec3" class="ml-2">
                          {{ $t("PointMec3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointMec4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointMec4" class="ml-2">
                          {{ $t("PointMec4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointMec5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointMec5" class="ml-2">
                          {{ $t("PointMec5") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointMec6"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointMec6" class="ml-2">
                          {{ $t("PointMec6") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="PointMecOther"
                          v-model="header.PointMecOther"
                          :placeholder="$t('PointMecOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>

                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointPrc1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointPrc1" class="ml-2">
                          {{ $t("PointPrc1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointPrc2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointPrc2" class="ml-2">{{
                          $t("PointPrc2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointPrc3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointElc3" class="ml-2">
                          {{ $t("PointPrc3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointPrc4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointPrc4" class="ml-2">
                          {{ $t("PointPrc4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PointPrc5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PointPrc5" class="ml-2">
                          {{ $t("PointPrc5") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="PointPrcOther"
                          v-model="header.PointPrcOther"
                          type="text"
                          :placeholder="$t('PointPrcOther')"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Method of Isolation Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.LOTO"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodElc1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodElc1" class="ml-2">
                          {{ $t("MethodElc1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodElc2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodElc2" class="ml-2">{{
                          $t("MethodElc2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodElc3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodElc3" class="ml-2">
                          {{ $t("MethodElc3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodElc4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodElc4" class="ml-2">
                          {{ $t("MethodElc4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="MethodElcOther"
                          v-model="header.MethodElcOther"
                          :placeholder="$t('MethodElcOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>

                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodMec1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodMec1" class="ml-2">
                          {{ $t("MethodMec1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodMec2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodMec2" class="ml-2">{{
                          $t("MethodMec2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodMec3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodMec3" class="ml-2">
                          {{ $t("MethodMec3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="MethodMecOther"
                          v-model="header.MethodMecOther"
                          :placeholder="$t('MethodMecOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>

                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodPrc1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodPrc1" class="ml-2">
                          {{ $t("MethodPrc1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodPrc2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodPrc2" class="ml-2">{{
                          $t("MethodPrc2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodPrc3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodPrc3" class="ml-2">
                          {{ $t("MethodPrc3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.MethodPrc4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="MethodPrc4" class="ml-2">
                          {{ $t("MethodPrc4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="MethodPrcOther"
                          v-model="header.MethodPrcOther"
                          :placeholder="$t('MethodPrcOther')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Erecting Scaffold or break-down"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.WAHP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Es1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Es1" class="ml-2"> {{ $t("Es1") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Es2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Es2" class="ml-2">{{ $t("Es2") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Es3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Es3" class="ml-2"> {{ $t("Es3") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Es4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Es4" class="ml-2"> {{ $t("Es4") }} </label>
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Working from Scaffold"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.WAHP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws1" class="ml-2"> {{ $t("Ws1") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws2" class="ml-2">{{ $t("Ws2") }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws3" class="ml-2"> {{ $t("Ws3") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws4" class="ml-2"> {{ $t("Ws4") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws5" class="ml-2"> {{ $t("Ws5") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws6"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws6" class="ml-2"> {{ $t("Ws6") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws7"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws7" class="ml-2"> {{ $t("Ws7") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws8"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws8" class="ml-2"> {{ $t("Ws8") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws9"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws9" class="ml-2"> {{ $t("Ws9") }} </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Ws10"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Ws10" class="ml-2">
                          {{ $t("Ws10") }}
                        </label>
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Mobile Elevated Work Platform Use (MEWP)"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.WAHP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Mewp1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Mewp1" class="ml-2">
                          {{ $t("Mewp1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Mewp2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Mewp2" class="ml-2">{{
                          $t("Mewp2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Mewp4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Mewp4" class="ml-2">
                          {{ $t("Mewp4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Mewp5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Mewp5" class="ml-2">
                          {{ $t("Mewp5") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Mewp6"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Mewp6" class="ml-2">
                          {{ $t("Mewp6") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Mewp7"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Mewp7" class="ml-2">
                          {{ $t("Mewp7") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Mewp8"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Mewp8" class="ml-2">
                          {{ $t("Mewp8") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Mewp3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Mewp3" class="ml-2">
                          {{ $t("Mewp3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="MewpLoad"
                          v-model="header.MewpLoad"
                          :placeholder="$t('MewpLoad')"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Isolations Required"
                      class="mb-4"
                      v-if="
                        this.permitCategory == this.$PERMIT_CATEGORY.CSEP ||
                        this.permitCategory == this.$PERMIT_CATEGORY.HOWP
                      "
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Isolation1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Isolation1" class="ml-2">
                          {{
                            this.permitCategory == this.$PERMIT_CATEGORY.HOWP
                              ? $t("Isolation1_howp")
                              : $t("Isolation1_csep")
                          }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Isolation2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Isolation2" class="ml-2">{{
                          this.permitCategory == this.$PERMIT_CATEGORY.HOWP
                            ? $t("Isolation2_howp")
                            : $t("Isolation2_csep")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Isolation3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Isolation3" class="ml-2">
                          {{
                            this.permitCategory == this.$PERMIT_CATEGORY.HOWP
                              ? $t("Isolation3_howp")
                              : $t("Isolation3_csep")
                          }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Isolation4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Isolation4" class="ml-2">
                          {{
                            this.permitCategory == this.$PERMIT_CATEGORY.HOWP
                              ? $t("Isolation4_howp")
                              : $t("Isolation4_csep")
                          }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.Isolation5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Isolation5" class="ml-2">
                          {{
                            this.permitCategory == this.$PERMIT_CATEGORY.HOWP
                              ? $t("Isolation5_howp")
                              : $t("Isolation5_csep")
                          }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="IsolationOther"
                          v-model="header.IsolationOther"
                          placeholder="Other"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Hot work on enclosed equipment/ tank required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.HOWP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.TankPrepared"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="TankPrepared" class="ml-2">
                          {{ $t("TankPrepared") }}</label
                        >
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Additional PPE Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.HOWP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PpeSafetyGlass"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PpeSafetyGlass" class="ml-2">
                          {{ $t("PpeSafetyGlass") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PpeEarMuff"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PpeEarMuff" class="ml-2">
                          {{ $t("PpeEarMuff") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PpeWeldingGoggle"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PpeWeldingGoggle" class="ml-2">
                          {{ $t("PpeWeldingGoggle") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PpeWeldingHeadShield"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PpeWeldingHeadShield" class="ml-2">
                          {{ $t("PpeWeldingHeadShield") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PpeWeldingGloves"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PpeWeldingGloves" class="ml-2">
                          {{ $t("PpeWeldingGloves") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PpeWeldingApron"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PpeWeldingApron" class="ml-2">
                          {{ $t("PpeWeldingApron") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PpeOthers"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PpeOthers" class="ml-2">
                          {{ $t("PpeOthers") }}</label
                        >
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Fire Monitoring and Fire Watcher Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.HOWP"
                    >
                      <div class="flex align-items-center mt-2 mb-2">
                        <YNCheckbox
                          v-model="header.FirewatcherTrained"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="FirewatcherTrained" class="ml-2">
                          {{ $t("FirewatcherTrained") }}
                          <span style="color: red">*</span></label
                        >
                      </div>
                      <Message severity="warn" :closable="false" class="mb-4">
                        <table>
                          <tr>
                            <td><b> WARNING!</b></td>
                          </tr>
                          <tr>
                            <td>
                              Fire watchers are aware of their duties and won’t
                              leave their post.
                            </td>
                          </tr>
                        </table>
                      </Message>
                      <FormField
                        :labelName="$t('FirewatcherUserId')"
                        fieldName="FirewatcherUserId"
                        v-model="header"
                        labelClass="col-4 mt-4"
                        fieldClass="col-6 md-6 mt-4"
                        :required="true"
                      >
                        <CustomSelect
                          v-model="header.FirewatcherUserId"
                          v-if="header"
                          :url="this.$API_URL + 'list/user_company_bycode'"
                          :minLength="0"
                          :filter="true"
                          :params="{ companyCode: header.VendorCode }"
                          :disabled="!canEdit"
                          @change="changeFireWathcer($event)"
                        />
                      </FormField>
                      <div
                        v-if="
                          !header.FirewatcherConfirmAt &&
                          header.FirewatcherUserId == this.idUser &&
                          header.isFireWatcher == 'Y'
                        "
                      >
                        <Button
                          icon="pi pi-save"
                          :label="$t('confirm')"
                          class="p-button-primary"
                          @click="confirmFireWatcher($event)"
                        />
                      </div>
                      <div v-if="header && header.FirewatcherConfirmAt">
                        <Message
                          severity="success"
                          :closable="false"
                          class="mb-4"
                        >
                          <table>
                            <tr>
                              <td><b> CONFIRMED!</b></td>
                            </tr>
                            <tr>
                              <td>
                                Confirm at
                                {{
                                  this.$formatDateTime(
                                    header.FirewatcherConfirmAt
                                  )
                                }}.
                              </td>
                            </tr>
                          </table>
                        </Message>
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Emergency Equipment Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.HOWP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.EeFireExtiguisher"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="EeFireExtiguisher" class="ml-2">
                          {{ $t("EeFireExtiguisher") }}
                          <span style="color: red">*</span></label
                        >
                      </div>
                      <div
                        class="flex align-items-center mt-2"
                        v-if="header && header.EeFireExtiguisher == 'Y'"
                      >
                        <CustomSelect
                          v-model="header.EeFireExtiguisherType"
                          :url="$API_URL + 'list/lookup'"
                          :minLength="0"
                          :filter="true"
                          :disabled="!canEdit"
                          :params="{
                            group: 'FIRE_EXTINGUISER',
                            allow_all: false,
                          }"
                        />
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.EeWaterHoseReel"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="EeWaterHoseReel" class="ml-2">{{
                          $t("EeWaterHoseReel")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.EeFireblanket"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="EeFireblanket" class="ml-2">
                          {{ $t("EeFireblanket") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <InputText
                          name="EeOthers"
                          v-model="header.EeOthers"
                          type="text"
                          placeholder="Other"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Ventilation Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.CSEP"
                    >
                      <div class="grid">
                        <div class="col-6">
                          <div class="flex align-items-center mt-2">
                            <YNCheckbox
                              v-model="header.Vent1"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="Vent1" class="ml-2">
                              {{ $t("Vent1") }}</label
                            >
                          </div>
                          <div class="flex align-items-center mt-2">
                            <YNCheckbox
                              v-model="header.Vent2"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="Vent2" class="ml-2">{{
                              $t("Vent2")
                            }}</label>
                          </div>
                          <div class="flex align-items-center mt-2">
                            <YNCheckbox
                              v-model="header.Vent3"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="Vent3" class="ml-2">
                              {{ $t("Vent3") }}
                            </label>
                          </div>
                          <div class="flex align-items-center mt-2">
                            <YNCheckbox
                              v-model="header.Vent4"
                              :disabled="!canEdit"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="Vent4" class="ml-2">
                              {{ $t("Vent4") }}
                            </label>
                          </div>
                        </div>
                        <div class="col-6">
                          <Message severity="info" :closable="false">
                            <table>
                              <tr>
                                <td><b>Info!</b></td>
                              </tr>
                              <tr>
                                <td>
                                  Minimum ventilation for entry without
                                  Breathing Apparatus, If safe to do so, is 4
                                  times the volume of the confined space, for a
                                  large storage tank this could be several days.
                                  Seek assistance if unsure how to calculate
                                  this.
                                </td>
                              </tr>
                            </table>
                          </Message>
                        </div>
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Stand-by Person & Rescue Plan Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.CSEP"
                    >
                      <div class="flex align-items-center mt-2 mb-2">
                        <YNCheckbox
                          v-model="header.Rescue1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="Rescue1" class="ml-2">
                          {{ $t("Rescue1") }}</label
                        >
                      </div>
                      <FormField
                        :labelName="$t('StandByPerson')"
                        fieldName="StandByPerson"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                      >
                        <InputText
                          name="StandByPerson"
                          v-model="header.StandByPerson"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('EmergencyResponder1')"
                        fieldName="EmergencyResponder1"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                      >
                        <InputText
                          name="EmergencyResponder1"
                          v-model="header.EmergencyResponder1"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </FormField>
                      <FormField
                        :labelName="$t('EmergencyResponder2')"
                        fieldName="EmergencyResponder2"
                        v-model="header"
                        v-if="!isCreate"
                        fieldClass="col-6"
                        labelClass="col-4"
                      >
                        <InputText
                          name="EmergencyResponder2"
                          v-model="header.EmergencyResponder2"
                          type="text"
                          v-if="header"
                          :disabled="!canEdit"
                        />
                      </FormField>
                    </Fieldset>
                    <Fieldset
                      legend="Additional Precautions Required"
                      class="mb-4"
                      v-if="this.permitCategory == this.$PERMIT_CATEGORY.CSEP"
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PrecReg1"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PrecReg1" class="ml-2">
                          {{ $t("PrecReg1") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PrecReg2"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PrecReg2" class="ml-2">{{
                          $t("PrecReg2")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PrecReg3"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PrecReg3" class="ml-2">
                          {{ $t("PrecReg3") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PrecReg4"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PrecReg4" class="ml-2">
                          {{ $t("PrecReg4") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PrecReg5"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PrecReg5" class="ml-2">
                          {{ $t("PrecReg5") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.PrecReg6"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="PrecReg6" class="ml-2">
                          {{ $t("PrecReg6") }}</label
                        >
                      </div>
                    </Fieldset>
                    <Fieldset
                      legend="Related Permit-to-Work Required"
                      class="mb-4"
                      v-if="
                        this.permitCategory == this.$PERMIT_CATEGORY.CSEP ||
                        this.permitCategory == this.$PERMIT_CATEGORY.HOWP ||
                        this.permitCategory == this.$PERMIT_CATEGORY.WAHP ||
                        this.permitCategory == this.$PERMIT_CATEGORY.LOTO
                      "
                    >
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.RelatedHowp"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="RelatedHowp" class="ml-2">
                          {{ $t("RelatedHowp") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.RelatedCowp"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="RelatedCowp" class="ml-2">{{
                          $t("RelatedCowp")
                        }}</label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.RelatedHlwp"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="RelatedHlwp" class="ml-2">
                          {{ $t("RelatedHlwp") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.RelatedExcp"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="RelatedExcp" class="ml-2">
                          {{ $t("RelatedExcp") }}
                        </label>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.RelatedLoto"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="RelatedLoto" class="ml-2">
                          {{ $t("RelatedLoto") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.RelatedCsep"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="RelatedCsep" class="ml-2">
                          {{ $t("RelatedCsep") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.RelatedLive"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="RelatedLive" class="ml-2">
                          {{ $t("RelatedLive") }}</label
                        >
                      </div>
                      <div class="flex align-items-center mt-2">
                        <YNCheckbox
                          v-model="header.RelatedWahp"
                          :disabled="!canEdit"
                          v-if="header"
                          :binary="true"
                        />
                        <label for="RelatedWahp" class="ml-2">
                          {{ $t("RelatedWahp") }}</label
                        >
                      </div>
                    </Fieldset>
                  </div>
                </div>
              </TabPanel>
              <TabPanel
                header="Atmospheric Monitoring"
                v-if="
                  (this.permitCategory == this.$PERMIT_CATEGORY.HOWP ||
                    this.permitCategory == this.$PERMIT_CATEGORY.CSEP) &&
                  header.Status != 'OPN' &&
                  header.Status != 'REL'
                "
                :key="this.$TAB_SECTION.ATM"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold"
                      >Atmospheric Monitoring</span
                    >
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'ATM')"
                      v-if="
                        (mode == this.$FORM_MODE_EDIT &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          (this.permitStatus == 'REJ' ||
                            this.permitStatus == 'OPN')) ||
                        (mode == this.$FORM_MODE_VIEW &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          this.permitStatus == 'PRG' &&
                          this.header.useAgt == false) ||
                        (mode == this.$FORM_MODE_VIEW &&
                          this.header.amIAgt == true &&
                          this.permitDelete == 'N' &&
                          this.permitStatus == 'PRG' &&
                          this.header.useAgt == true)
                      "
                    />
                  </template>
                </Toolbar>
                <br />
                <PermitControl
                  :dataArray="header.AtmControls"
                  :dataModel="dataModelAtmControl"
                  :mode="mode"
                  v-if="header"
                  :header="header"
                />
              </TabPanel>
              <TabPanel
                header="Permit Checklist"
                :key="this.$TAB_SECTION.CHECKLIST"
              >
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Permit Checklist</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-check-circle"
                      :label="$t('save')"
                      class="p-button-success"
                      @click="confirmSection($event, 'CHECKLIST')"
                      v-if="
                        (mode == this.$FORM_MODE_EDIT &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          this.permitStatus == 'REJ') ||
                        (mode == this.$FORM_MODE_EDIT &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          this.permitStatus == 'OPN' &&
                          this.isOfflinePermitSetting == 'Y') ||
                        (mode == this.$FORM_MODE_VIEW &&
                          this.permitUser == this.userName &&
                          this.permitDelete == 'N' &&
                          this.permitStatus == 'PRG' &&
                          this.permitChecklistReviewed == 'N')
                      "
                    />
                  </template> </Toolbar
                ><br />
                <div class="mb-4">
                  <Message severity="info" icon="pi pi-send" :closable="false">
                    <table>
                      <tr>
                        <td><b>Direction!</b></td>
                      </tr>
                      <tr>
                        <td>
                          The verify button is at the bottom on each type of
                          checklist <br />
                          The verification button appears only on accounts with
                          role "Plant Responsible (PIC)" on this permit.
                        </td>
                      </tr>
                    </table>
                  </Message>
                  <div class="col-12">
                    <Fieldset legend="Permit Method">
                      Online Permit Screening at this Company is active. Please
                      select the type of permit checklist you wish to use.
                      <div class="col-6">
                        <CustomSelect
                          v-model="header.IsOnline"
                          v-if="header"
                          :url="this.$API_URL + 'list/lookup'"
                          placeholder="Please Select Method"
                          :minLength="0"
                          :filter="true"
                          :params="{
                            group: 'PERMIT_CHECKLIST_METHOD',
                            allow_all: false,
                          }"
                          :disabled="
                            (this.permitStatus == 'OPN' &&
                              this.isOfflinePermitSetting == 'N') ||
                            this.permitStatus != 'OPN'
                          "
                          @change="changePermitMethod($event)"
                        />
                      </div>
                    </Fieldset>
                  </div>
                </div>
                <div class="col-12" v-if="this.isOnlinePermitChecklist == 'Y'">
                  <table id="headerPermit">
                    <tr>
                      <td>Permit Number</td>
                      <td colspan="2">
                        <b>{{ header.PermitNumber }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Checklist Completed by (Permit User)</td>
                      <td>
                        <b>{{ header.PermitUser }}</b>
                      </td>
                      <td>
                        <b>{{
                          header && header.VerifyPreUsername != null
                            ? this.convertDate(header.CreatedDate)
                            : "Not yet completed"
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        A. Preparation Checklist Verified by (Permit Authoriser)
                        -
                        <b
                          >{{
                            this.prePrecentage == null ? 0 : this.prePrecentage
                          }}%</b
                        >
                      </td>
                      <td>
                        <b>{{
                          header && header.VerifyPreUsername != null
                            ? header.VerifyPreUsername
                            : "N/A"
                        }}</b>
                      </td>
                      <td>
                        <b>{{
                          header && header.VerifyPreUsername != null
                            ? this.convertDate(header.VerifyPreDate)
                            : "Not yet verified"
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        B. During Work Checklist Verified by (Permit Authoriser)
                        -
                        <b
                          >{{
                            this.durPrecentage == null ? 0 : this.durPrecentage
                          }}%</b
                        >
                      </td>
                      <td>
                        <b>{{
                          header && header.VerifyDurUsername != null
                            ? header.VerifyDurUsername
                            : "N/A"
                        }}</b>
                      </td>
                      <td>
                        <b>{{
                          header && header.VerifyDurUsername != null
                            ? this.convertDate(header.VerifyDurDate)
                            : "Not yet verified"
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        C. Post Work Checklist Verified by (Permit Authoriser) -
                        <b
                          >{{
                            this.postPrecentage == null
                              ? 0
                              : this.postPrecentage
                          }}%</b
                        >
                      </td>
                      <td>
                        <b>{{
                          header && header.VerifyPostUsername != null
                            ? header.VerifyPostUsername
                            : "N/A"
                        }}</b>
                      </td>
                      <td>
                        <b>{{
                          header && header.VerifyPostUsername != null
                            ? this.convertDate(header.VerifypostDate)
                            : "Not yet verified"
                        }}</b>
                      </td>
                    </tr>
                  </table>
                  <div class="mb-4 mt-4">
                    <Message
                      severity="warn"
                      icon="pi pi-send"
                      :closable="false"
                    >
                      <table>
                        <tr>
                          <td>
                            <b
                              >All the below checks should be marked “YES”
                              before Hot Work can commence. Otherwise stop /
                              postpone the work until all the requirements have
                              been met and verified by the Wilmar Supervisor.</b
                            >
                          </td>
                        </tr>
                      </table>
                    </Message>
                  </div>
                  <div
                    v-if="
                      this.mode == this.$FORM_MODE_VERIFY &&
                      this.permitPIC == this.userName &&
                      this.permitDelete == 'N'
                    "
                    class="mb-4"
                  >
                    <PermitChecklistPre
                      :dataArray="header.PermitChecklists"
                      :dataModel="dataModelPermitChecklist"
                      v-if="header"
                      :header="header"
                      :mode="mode"
                      :status="this.permitStatus"
                      :preuser="header.PreUser"
                      :duruser="header.DurUser"
                      :postuser="header.PostUser"
                      :permitReview="this.permitChecklistReviewed"
                    />
                    <div
                      v-if="
                        this.mode == this.$FORM_MODE_VERIFY &&
                        this.permitPIC == this.userName &&
                        this.permitDelete == 'N'
                      "
                      class="mb-4"
                    >
                      <Button
                        icon="pi pi-check-circle"
                        :label="$t('pre_verification')"
                        class="p-button-info mt-3"
                        @click="confirmVerif($event, 'PRE')"
                        :disabled="
                          this.distanceMi > this.radius ||
                          (this.permitStatus != 'PRG' &&
                            this.permitStatus != 'COM') ||
                          this.prePrecentage != 100 ||
                          (header && header.VerifyPreUsername != null)
                        "
                      />
                    </div>
                    <PermitChecklistDur
                      :dataArray="header.PermitChecklists"
                      :dataModel="dataModelPermitChecklist"
                      v-if="header"
                      :header="header"
                      :mode="mode"
                      :status="this.permitStatus"
                      :preuser="header.PreUser"
                      :duruser="header.DurUser"
                      :postuser="header.PostUser"
                      :permitReview="this.permitChecklistReviewed"
                    />
                    <div
                      v-if="
                        this.mode == this.$FORM_MODE_VERIFY &&
                        this.permitPIC == this.userName &&
                        this.permitDelete == 'N'
                      "
                      class="mb-4"
                    >
                      <Button
                        icon="pi pi-check-circle"
                        :label="$t('dur_verification')"
                        class="p-button-info mt-3"
                        @click="confirmVerif($event, 'DUR')"
                        :disabled="
                          this.distanceMi > this.radius ||
                          (this.permitStatus != 'PRG' &&
                            this.permitStatus != 'COM') ||
                          this.durPrecentage != 100 ||
                          this.prePrecentage != 100 ||
                          (header && header.VerifyDurUsername != null)
                        "
                      />
                    </div>
                    <PermitChecklistPost
                      :dataArray="header.PermitChecklists"
                      :dataModel="dataModelPermitChecklist"
                      v-if="header"
                      :header="header"
                      :mode="mode"
                      :status="this.permitStatus"
                      :preuser="header.PreUser"
                      :duruser="header.DurUser"
                      :postuser="header.PostUser"
                      :permitReview="this.permitChecklistReviewed"
                    />
                    <div
                      v-if="
                        this.mode == this.$FORM_MODE_VERIFY &&
                        this.permitPIC == this.userName &&
                        this.permitDelete == 'N'
                      "
                      class="mb-4"
                    >
                      <Button
                        icon="pi pi-check-circle"
                        :label="$t('post_verification')"
                        class="p-button-info mt-3"
                        @click="confirmVerif($event, 'POST')"
                        :disabled="
                          this.distanceMi > this.radius ||
                          (this.permitStatus != 'PRG' &&
                            this.permitStatus != 'COM') ||
                          this.postPrecentage != 100 ||
                          this.prePrecentage != 100 ||
                          (header && header.VerifyPostUsername != null)
                        "
                      />
                    </div>
                  </div>
                  <div v-else>
                    <PermitChecklist
                      :dataArray="header.PermitChecklists"
                      :dataModel="dataModelPermitChecklist"
                      v-if="header"
                      :header="header"
                      :mode="mode"
                      :status="this.permitStatus"
                      :preuser="header.PreUser"
                      :duruser="header.DurUser"
                      :postuser="header.PostUser"
                      :permitReview="this.permitChecklistReviewed"
                    />
                  </div>
                </div>
                <div class="col-12" v-else>
                  <table id="headerPermit">
                    <tr>
                      <td>Permit Number</td>
                      <td colspan="2">
                        <b>{{ header.PermitNumber }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Checklist Completed by (Permit User)</td>
                      <td>
                        <b>{{ header.PermitUser }}</b>
                      </td>
                      <td>
                        <b>{{
                          header && header.VerifyPreUsername != null
                            ? this.convertDate(header.CreatedDate)
                            : "Not yet completed"
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        A. Preparation Checklist Verified by (Permit Authoriser)
                        -
                        <b
                          >{{
                            this.prePrecentage == null ? 0 : this.prePrecentage
                          }}%</b
                        >
                      </td>
                      <td>
                        <CustomFileUpload
                          :fileModels="docPreModel"
                          :multiple="false"
                          :showUploadButton="false"
                          :showCancelButton="false"
                          :customUpload="false"
                          :maxFileSize="5000000"
                          :accept="'image/png,image/jpg,image/jpeg,application/pdf'"
                          @select="onFileSelectDocPre"
                          :disabled="
                            (mode != this.$FORM_MODE_VIEW &&
                              this.permitStatus != 'PRG') ||
                            mode == this.$FORM_MODE_VERIFY ||
                            this.permitChecklistReviewed == 'Y'
                          "
                          @remove="onFileRemoveDocPre"
                        />
                        <CustomFileUpload
                          :fileModels="this.viewFilePres"
                          :multiple="false"
                          :showUploadButton="false"
                          :showCancelButton="false"
                          :customUpload="false"
                          @select="onFileSelectDocPre"
                          @remove="onFileRemoveDocPre"
                          :viewOnly="true"
                          :showHeader="false"
                          @download="onDownloadFileDocPre"
                        />
                      </td>
                      <td>
                        <Button
                          label="Template Pre"
                          @click="getTemplate('pre')"
                          icon="pi pi-cloud-download"
                        />
                      </td>
                    </tr>
                    <tr
                      v-if="
                        this.mode == this.$FORM_MODE_VERIFY &&
                        this.permitPIC == this.userName &&
                        this.permitDelete == 'N'
                      "
                    >
                      <td colspan="3">
                        <Button
                          label="Verify Pre"
                          icon="pi pi-check-circle"
                          @click="confirmVerif($event, 'PRE')"
                          :disabled="
                            this.distanceMi > this.radius ||
                            (this.permitStatus != 'PRG' &&
                              this.permitStatus != 'COM') ||
                            this.prePrecentage != 100 ||
                            (header && header.VerifyPreUsername != null)
                          "
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        B. During & Post Work Checklist Verified by (Permit
                        Authoriser) -
                        <b
                          >{{
                            this.durPrecentage == null ? 0 : this.durPrecentage
                          }}%</b
                        >
                      </td>
                      <td>
                        <CustomFileUpload
                          :fileModels="docDurPostModel"
                          :multiple="false"
                          :showUploadButton="false"
                          :showCancelButton="false"
                          :customUpload="false"
                          :maxFileSize="5000000"
                          :accept="'image/png,image/jpg,image/jpeg,application/pdf'"
                          @select="onFileSelectDocDurPost"
                          :disabled="
                            (mode != this.$FORM_MODE_VIEW &&
                              this.permitStatus != 'PRG') ||
                            mode == this.$FORM_MODE_VERIFY ||
                            this.permitChecklistReviewed == 'Y'
                          "
                          @remove="onFileRemoveDocDurPost"
                        />
                        <CustomFileUpload
                          :fileModels="this.viewFileDurPosts"
                          :multiple="false"
                          :showUploadButton="false"
                          :showCancelButton="false"
                          :customUpload="false"
                          @select="onFileSelectDocDurPost"
                          @remove="onFileRemoveDocDurPost"
                          :viewOnly="true"
                          :showHeader="false"
                          @download="onDownloadFileDocDurPost"
                        />
                      </td>
                      <td>
                        <Button
                          label="Template During & Post"
                          icon="pi pi-cloud-download"
                          @click="getTemplate('dur')"
                        />
                      </td>
                    </tr>
                    <tr
                      v-if="
                        this.mode == this.$FORM_MODE_VERIFY &&
                        this.permitPIC == this.userName &&
                        this.permitDelete == 'N'
                      "
                    >
                      <td colspan="3">
                        <Button
                          label="Verify Post & Dur"
                          icon="pi pi-check-circle"
                          @click="confirmVerif($event, 'DUR')"
                          :disabled="
                            this.distanceMi > this.radius ||
                            (this.permitStatus != 'PRG' &&
                              this.permitStatus != 'COM') ||
                            this.durPrecentage != 100 ||
                            this.prePrecentage != 100 ||
                            (header && header.VerifyDurUsername != null)
                          "
                        />
                      </td>
                    </tr>
                  </table>
                </div>
              </TabPanel>
              <TabPanel
                header="Authorisation & Acceptance"
                :key="this.$TAB_SECTION.AUTHOR"
              >
                <div class="grid">
                  <div class="col-10">
                    <table style="width: 70%">
                      <tr>
                        <td>
                          <div class="flex align-items-center">
                            <YNCheckbox
                              v-model="header.AgreementDeclaration"
                              :disabled="header.AgreementDeclarationText"
                              v-if="header"
                              :binary="true"
                            />
                            <label for="AgreementDeclaration" class="ml-2">
                              I agreed that all precautions and instructions are
                              adhered to and I fully understand the nature and
                              extend of works undertaken by my workers and me.
                            </label>
                          </div>
                        </td>
                        <td>
                          <div v-if="!header.AgreementDeclarationText">
                            <Button
                              icon="pi pi-save"
                              :label="$t('sign_off')"
                              :disabled="header.AgreementDeclaration != 'Y'"
                              class="p-button-primary"
                              @click="signoff($event)"
                            />
                          </div>
                          <div v-else="">
                            <QRCode
                              :refNumber="this.permitNumber"
                              :section="'DECLARATION_PERMIT'"
                              :refId="this.id"
                            />
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <!-- <div class="col-6">
                                            <Fieldset legend="Permit Valid From: Maximum for one shift only">
                                                <table>
                                                        <tr>
                                                            <td>Date</td>
                                                            <td>:</td>
                                                            <td>{{moment(header.PermitDate).format('dd/mm/yyyy').toString()}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Time</td>
                                                            <td>:</td>
                                                            <td>{{moment(header.StartTime).format('HH:mm').toString()}} - {{moment(header.FinishTIme).format('HH:mm').toString()}}</td>
                                                        </tr>
                                                    </table>
                                            </Fieldset>
                                        </div> -->
                </div>
              </TabPanel>
              <TabPanel header="Location" :key="this.$TAB_SECTION.LOCATION">
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Location</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirm($event)"
                      v-if="
                        mode == this.$FORM_MODE_EDIT &&
                        this.permitUser == this.userName &&
                        this.permitDelete == 'N' &&
                        (this.permitStatus == 'REJ' ||
                          this.permitStatus == 'OPN')
                      "
                    />
                  </template> </Toolbar
                ><br />
                <div class="col-12">
                  <FormField
                    :labelName="$t('permit_lat')"
                    fieldName="PermitLat"
                    v-model="header"
                    v-if="!isCreate"
                    fieldClass="col-6"
                    labelClass="col-4"
                  >
                    <InputText
                      name="PermitLat"
                      v-model="header.PermitLat"
                      type="text"
                      v-if="header"
                      :readonly="true"
                    />
                  </FormField>
                  <FormField
                    :labelName="$t('permit_long')"
                    fieldName="PermitLong"
                    v-model="header"
                    v-if="!isCreate"
                    fieldClass="col-6"
                    labelClass="col-4"
                  >
                    <InputText
                      name="PermitLong"
                      v-model="header.PermitLong"
                      type="text"
                      v-if="header"
                      :readonly="true"
                    />
                  </FormField>
                </div>
                <div class="col-12">
                  <div style="min-height: 700px">
                    <div></div>
                    <div
                      style="width: 100%; height: 900px"
                      id="map_canvas"
                    ></div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Extend" :key="this.$TAB_SECTION.EXTEND">
                <Toolbar>
                  <template #left>
                    <span class="text-xl font-bold">Permit Extend</span>
                  </template>
                  <template #right>
                    <Button
                      icon="pi pi-save"
                      :label="$t('save')"
                      class="p-button-success mr-2"
                      @click="confirmSection($event, 'EXTEND')"
                      v-if="
                        mode == this.$FORM_MODE_VIEW &&
                        this.permitStatus == 'PRG' &&
                        this.Extended != 'Y' &&
                        this.permitUser == this.userName
                      "
                    />
                  </template> </Toolbar
                ><br />
                <Fieldset legend="Extend" class="mb-4">
                  <div class="flex align-items-center mt-4">
                    <YNCheckbox
                      v-model="header.IsExtend"
                      :disabled="
                        this.permitStatus != 'PRG' ||
                        (this.permitStatus == 'PRG' && this.Extended == 'Y') ||
                        this.permitUser != this.userName
                      "
                      v-if="header"
                      :binary="true"
                    />
                    <label for="IsExtend" class="ml-2"
                      >{{ $t("extend_info") }}
                    </label>
                  </div>
                  <div v-if="header && header.IsExtend == 'Y'" class="mt-4">
                    <FormField
                      :labelName="$t('ExtStartTime')"
                      fieldName="ExtStartTime"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <div
                        class="field grid"
                        style="margin-bottom: 0 !important"
                      >
                        <div class="col-5">
                          <DatePicker
                            id="calendar-timeonly"
                            :class="{
                              'p-invalid': submitted && !header.ExtStartTime,
                            }"
                            momentFormat="HH:mm"
                            v-if="header"
                            v-model="header.ExtStartTime"
                            timeOnly
                            :disabled="
                              this.permitStatus != 'PRG' ||
                              this.Extended == 'Y' ||
                              this.permitUser != this.userName
                            "
                          />
                          <small
                            v-if="
                              header &&
                              !header.ExtStartTime &&
                              submitted &&
                              this.permitStatus == 'PRG' &&
                              mode == this.$FORM_MODE_VIEW &&
                              header.IsExtend == 'Y'
                            "
                            class="p-error"
                            >{{
                              $t("is_required").replace(
                                "Value",
                                $t("ext_start_time")
                              )
                            }}
                          </small>
                        </div>
                        <label for="FinishTime" class="col-2">Finish</label>
                        <div class="col-5">
                          <DatePicker
                            id="calendar-timeonly"
                            momentFormat="HH:mm"
                            :class="{
                              'p-invalid': submitted && !header.ExtFinsihTime,
                            }"
                            v-if="header"
                            v-model="header.ExtFinsihTime"
                            timeOnly
                            :disabled="
                              this.permitStatus != 'PRG' || this.Extended == 'Y'
                            "
                          />
                          <small
                            v-if="
                              header &&
                              !header.ExtFinsihTime &&
                              submitted &&
                              this.permitStatus == 'PRG' &&
                              mode == this.$FORM_MODE_VIEW &&
                              header.IsExtend == 'Y'
                            "
                            class="p-error"
                            >{{
                              $t("is_required").replace(
                                "Value",
                                $t("ext_finish_time")
                              )
                            }}
                          </small>
                        </div>
                      </div>
                    </FormField>
                    <FormField
                      :labelName="$t('ExtDesc')"
                      fieldName="ExtDesc"
                      v-model="header"
                      fieldClass="col-6"
                      labelClass="col-4"
                    >
                      <InputText
                        name="ExtDesc"
                        v-model="header.ExtDesc"
                        type="text"
                        :class="{
                          'p-invalid': submitted && !header.ExtDesc,
                        }"
                        v-if="header"
                        :disabled="
                          this.permitStatus != 'PRG' || this.Extended == 'Y'
                        "
                      />
                      <small
                        v-if="
                          header &&
                          !header.ExtDesc &&
                          submitted &&
                          this.permitStatus == 'PRG' &&
                          mode == this.$FORM_MODE_VIEW &&
                          header.IsExtend == 'Y'
                        "
                        class="p-error"
                        >{{
                          $t("is_required").replace("Value", $t("ext_desc"))
                        }}
                      </small>
                    </FormField>
                  </div>
                </Fieldset>
              </TabPanel>
            </TabView>
          </div>
          <!-- </BlockUI> -->
        </div>
      </template>
    </Card>
  </form>

  <Dialog
    header="Outstanding Permit"
    v-model:visible="isHaveOsPermit"
    :closeOnEscape="true"
    :closable="true"
    :modal="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    :style="{ width: '60vw' }"
  >
    <span v-show="errMessage" class="p-error">{{ errMessage }}</span>
    <DataTable
      :loading="!dataPermitOS"
      :value="dataPermitOS ? dataPermitOS : null"
      responsiveLayout="scroll"
      class="p-datatable-sm editable-cells-table"
      :rowClass="setCurrentRow"
    >
      <Column
        field="osPermit"
        :header="$t('permit_number')"
        key="osPermit"
        style="width: 10%"
      >
        <template #body="slotProps">
          <!-- <a :href="'Permit/Editor?mode=View&id=' + data.Id" target="_blank">{{ data.Permit_Number }}
                        </a> -->
          <Button
            :label="slotProps.data.osPermit"
            class="p-button-text"
            @click="goToDetail(slotProps)"
          />
        </template>
      </Column>
      <Column
        field="createdByPermit"
        :header="$t('created_by')"
        key="createdByPermit"
        style="width: 10%"
      >
      </Column>
      <Column
        field="daysPermit"
        :header="$t('days')"
        key="daysPermit"
        style="width: 10%"
      >
      </Column>
      <Column
        field="statusPermit"
        :header="$t('status')"
        key="statusPermit"
        style="width: 10%"
      >
      </Column>
      <Column
        field="datePermit"
        :header="$t('date')"
        key="datePermit"
        style="width: 15%"
      >
        <template #body="{ data }">
          {{ this.$formatDate(data.datePermit) }}
        </template>
      </Column>
      <Column
        field="WillBeOSPermit"
        :header="$t('WillBeOSPermit')"
        key="WillBeOSPermit"
        style="width: 10%"
      >
      </Column>
    </DataTable>
  </Dialog>

  <!-- <ShowReport
    :title="title"
    :isVisible="showTemplatePC"
    :reportTbl="this.templateTbl"
    @close="resetBtn()"
  /> -->

  <PdfReport
    :isVisible="showTemplatePC"
    :modelValue="header && header.PermitChecklists"
    :typePermitCheclist="permitChecklistSection"
    :permitNumber="permitNumber"
    :permitStatus="statuspermit"
    :permitUser="permitUser"
    :permitCategory="permitCategory"
    @close="resetBtn()"
  />

  <FileViewer
    v-if="dialogVisibleView"
    :isVisible="dialogVisibleView"
    :urlFile="this.fileUrlView"
    :isPdf="this.isPdf"
    :isImg="this.isImg"
    :fileNames="this.fileName"
    :sectionFile="this.sectionFile"
    @hide="hideViewer"
  />
</template>

<script>
import moment from "moment";
import Exec from "./v1/_Exec.vue";
import Area from "./v1/_Area.vue";
import Risk from "./v1/_Risk.vue";
import Supervision from "./v1/_Supervision.vue";
import Tools from "./v1/_Tools.vue";
import Sop from "./v1/_SOP.vue";
import Emergency from "./v1/_Emergency.vue";
import Close from "./v1/_Close.vue";
import Worker from "./v2/_Worker.vue";
import Entrance from "./v2/_Entrance.vue";
import Acceptance from "./v2/_Acceptance.vue";
import Completion from "./v2/_Completion.vue";
import Location from "./v2/_Location.vue";
import PermitChecklist from "./v2/_PermitChecklist.vue";
import PermitChecklistPre from "./v2/_PermitChecklistPre.vue";
import PermitChecklistDur from "./v2/_PermitChecklistDur.vue";
import PermitChecklistPost from "./v2/_PermitChecklistPost.vue";
import PermitControl from "./v2/_PermitControl.vue";
import Preparation from "./v2/_Preparation.vue";
import QRCode from "./_QRCode.vue";
import Agt from "./v2/_Agt.vue";
import ShowReport from "../Report/ShowReport.vue";
import PdfReport from "./PdfReport.vue";
export default {
  name: "Editor",
  components: {
    Exec: Exec,
    Area: Area,
    Risk: Risk,
    Supervision: Supervision,
    Tools: Tools,
    Sop: Sop,
    Emergency: Emergency,
    Close: Close,
    Worker: Worker,
    Entrance: Entrance,
    Acceptance: Acceptance,
    Completion: Completion,
    Location: Location,
    PermitChecklist: PermitChecklist,
    PermitChecklistPre: PermitChecklistPre,
    PermitChecklistDur: PermitChecklistDur,
    PermitChecklistPost: PermitChecklistPost,
    Preparation: Preparation,
    QRCode: QRCode,
    PermitControl: PermitControl,
    Agt: Agt,
    ShowReport: ShowReport,
    PdfReport: PdfReport,
  },
  data() {
    return {
      indexName: "PermitIndex",
      url: this.$API_URL + "permit/",
      urlOsPermit: this.$API_URL + "permit/ospermit",
      urlTemplate: this.$API_URL + "permit/templatepermitc",
      urlSignOff: this.$API_URL + "permit/signoff",
      urlVerif: this.$API_URL + "permit/verif",
      urlSuspend: this.$API_URL + "permit/suspend",
      urlCleanApv: this.$API_URL + "permit/clean_approver",
      urlResetVerif: this.$API_URL + "permit/reset_verif",
      urlComplete: this.$API_URL + "permit/complete",
      urlConfirmFire: this.$API_URL + "permit/confirmfirewatcher",
      urlsavePermitWorker: this.$API_URL + "permit/savepermitworker",
      urlsavePermitTools: this.$API_URL + "permit/savepermittools",
      urlsavePermitSpv: this.$API_URL + "permit/savepermitspv",
      userTimeZoneOffset: moment().utcOffset() / 60,
      userTime: moment().format("HH:mm"),
      timezoneUserOffset: this.$store.getters.getTimezoneOffset,
      header: null,
      detail: null,
      dataPermitOS: null,
      isHaveOsPermit: false,
      isOnlinePermitChecklist: "Y",
      isOfflinePermitSetting: "N",
      errMessage: null,
      mode: "",
      id: 0,
      qrData: null,
      qrSignOff: null,
      imgCloseModel: [],
      docPreModel: [],
      docDurPostModel: [],
      viewFilePres: [],
      viewFileDurPosts: [],
      permitNumber: null,
      permitChecklistSection: "",
      formEditable: true,
      isGlobalAdmin: this.$store.getters.getIsAdmin,
      companyCodeUser: this.$store.getters.getCompanyCode,
      companyIdUser: this.$store.getters.getCompanyId,
      idUser: this.$store.getters.getUserId,
      userName: this.$store.getters.getUsername,
      getLang: this.$store.getters.getLanguage,
      permitUser: "",
      permitPIC: "",
      permitStatus: "",
      permitChecklistReviewed: "",
      permitCompanyCode: "",
      viewFileCloses: [],
      statuspermit: null,
      submitted: false,
      dataModel: false,
      dataModelExec: null,
      dataModelArea: null,
      dataModelRisk: null,
      dataModelSupervision: null,
      dataModelPermitChecklist: null,
      dataModelTools: null,
      dataModelSop: null,
      dataModelEmegergency: null,
      dataModelClose: null,
      dataModelPermitLogs: null,
      dataModelRelease: null,
      dataModelPermitWorker: null,
      dataModelAgtPerson: null,
      dataModelEntrance: null,
      dataModelSignOff: null,
      dataModelVerif: null,
      dataModelPermit: null,
      dataModelFireWather: null,
      dataModelAtmControl: null,
      permitVersion: null,
      permitCategory: null,
      showInitMtc: null,
      FinishsTime: null,
      statusPermit: "",
      isMtcPermit: "N",
      isGeneralFull: false,
      distanceMi: null,
      distanceTime: null,
      prePrecentage: null,
      durPrecentage: null,
      postPrecentage: null,
      overallPrecentage: null,
      permitWorkerExist: null,
      sectionTab: null,
      permitExtend: "N",
      permitDelete: "N",
      visible: false,
      visibleExtend: false,
      visibleClean: false,
      visibleResetVerif: false,
      Extended: null,
      radius: 3000,
      loading: false,
      headerTemplate: {
        Type: null,
        Document_Category: null,
      },
      showTemplatePC: false,
      templateTbl: null,
      fileUrlView: null,
      fileUrl: null,
      fileName: null,
      fileTypeView: null,
      fileHref: null,
      sectionFile: null,
      isImg: false,
      isPdf: false,
      dialogVisibleView: false,
      selectedTab: "GNR",
      // dataPermitLogs: [
      //   { field: "ActionRole", header: "Role" },
      //   { field: "ActionBy", header: "Action By" },
      //   { field: "Action_Date", header: "Action Date" },
      //   { field: "Notes", header: "Notes" },
      // ],
      dataRelease: [
        { field: "ActionRole", header: "Role" },
        { field: "ActionBy", header: "Username" },
        { field: "Fullname", header: "Fullname" },
        { field: "Category", header: "Category" },
        { field: "Level", header: "Level" },
        { field: "Status", header: "Status" },
        { field: "ApprovedBy", header: "Approved By" },
        { field: "Remark", header: "Remark" },
        { field: "UrlWA", header: "Send WA Notification" },
      ],
      dataHeaderPermitChecklist: [
        { field: "ActionRole", header: "Role" },
        { field: "ActionBy", header: "Name" },
        { field: "Category", header: "Category" },
        { field: "Level", header: "Level" },
        { field: "Status", header: "Status" },
        { field: "ApprovedBy", header: "ApprovedBy" },
        { field: "Remark", header: "Remark" },
      ],
    };
  },
  methods: {
    hideRow(data) {
      return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
    },
    getData() {
      this.$emit("blockBody");
      this.loading = true;
      this.dataModelPermitLogs = null;
      var self = this;
      this.$axios
        .get(
          this.url +
            this.id +
            "/" +
            this.mode +
            "/" +
            this.getLang +
            "/" +
            this.selectedTab
        )
        .then((response) => {
          self.header = response.data.data.header;
          self.header.mode = self.mode;

          self.dataModel = response.data.data.detail;
          self.dataModelTools = response.data.data.permittools;
          self.dataModelRisk = response.data.data.permitrisk;
          self.dataModelSop = response.data.data.permitsops;
          self.dataModelSupervision = response.data.data.permitsupervision;
          self.dataModelPermitWorker = response.data.data.permitworker;
          self.dataModelAgtPerson = response.data.data.permitagt;
          self.dataModelEntrance = response.data.data.entrance;
          self.dataModelPermitChecklist = response.data.data.permitchecklist;
          self.dataModelAtmControl = response.data.data.permitatmcontrol;
          self.permitWorkerExist = response.data.data.header.PermitWorkers;
          self.dataModelRelease = response.data.data.header.ApprovalLogs;

          self.viewFilePres = response.data.data.header.viewFilesPre;
          self.viewFileDurPosts = response.data.data.header.viewFilesDurPost;
          self.viewFileCloses = response.data.data.header.viewFilesClose;

          self.statuspermit = response.data.data.header.Status;
          self.permitVersion =
            response.data.data.header.Version != null
              ? response.data.data.header.Version
              : 1;
          self.permitCategory = response.data.data.header.Category;
          self.permitNumber = response.data.data.header.PermitNumber;
          self.permitUser = response.data.data.header.PermitUser;
          self.permitStatus = response.data.data.header.Status;
          self.permitChecklistReviewed =
            response.data.data.header.ChecklistReviewed;
          self.permitCompanyCode = response.data.data.header.CompanyCode;
          self.permitPIC = response.data.data.header.VerifPIC;
          self.permitDelete = response.data.data.header.IsDeleted;
          self.permitExtend =
            response.data.data.header.ExtStartTime != null ? "Y" : "N";
          self.isOfflinePermitSetting =
            response.data.data.header.isPermitOfflineOn;

          self.qrData = response.data.data.header.QrCodePermit;
          self.qrSignOff = response.data.data.header.QrCodePermitSignOff;

          self.isOnlinePermitChecklist = response.data.data.header.IsOnline;
          self.isGeneralFull = response.data.data.header.isGeneralComplete;
          self.prePrecentage = response.data.data.header.PrePrecentage;
          self.durPrecentage = response.data.data.header.DurPrecentage;
          self.postPrecentage = response.data.data.header.PostPrecentage;
          self.overallPrecentage = response.data.data.header.OverallPercentage;

          self.Extended =
            response.data.data.header.IsExtend != null
              ? response.data.data.header.IsExtend
              : "N";

          self.header.workStartDate = new Date(
            moment(response.data.data.header.workStartDate).format("YYYY-MM-DD")
          );
          self.header.PermitDate =
            response.data.data.header.PermitDate != null
              ? new Date(
                  moment(response.data.data.header.PermitDate)
                    .add(self.timezoneUserOffset, "hours")
                    .format("YYYY-MM-DD")
                )
              : null;
          self.header.StartTime = moment(
            response.data.data.header.StartTime,
            "YYYY-MM-DDTHH:mm:ss"
          )
            .add(self.timezoneUserOffset, "hours")
            .format();
          self.header.FinishTime = moment(
            response.data.data.header.FinishTime,
            "YYYY-MM-DDTHH:mm:ss"
          )
            .add(self.timezoneUserOffset, "hours")
            .format();
          self.header.ReqEntryTime =
            response.data.data.header.ReqEntryTime != null
              ? moment(
                  response.data.data.header.ReqEntryTime,
                  "YYYY-MM-DDTHH:mm:ss"
                )
                  .add(self.timezoneUserOffset, "hours")
                  .format()
              : null;
          self.header.ReqLeaveTime =
            response.data.data.header.ReqLeaveTime != null
              ? moment(
                  response.data.data.header.ReqLeaveTime,
                  "YYYY-MM-DDTHH:mm:ss"
                )
                  .add(self.timezoneUserOffset, "hours")
                  .format()
              : null;
          self.header.ExtStartTime =
            response.data.data.header.ExtStartTime != null
              ? moment(
                  response.data.data.header.ExtStartTime,
                  "YYYY-MM-DDTHH:mm:ss"
                )
                  .add(self.timezoneUserOffset, "hours")
                  .format()
              : null;
          self.header.ExtFinsihTime =
            response.data.data.header.ExtFinsihTime != null
              ? moment(
                  response.data.data.header.ExtFinsihTime,
                  "YYYY-MM-DDTHH:mm:ss"
                )
                  .add(self.timezoneUserOffset, "hours")
                  .format()
              : null;

          self.loading = false;
          self.renderMap();
          self.$emit("unblockBody");
        })
        .catch(function (error) {
          self.loading = true;
          alert(error);
        });
    },
    onTabChange(event) {
      const tabIndex = event.index;
      const tabComponent = this.$refs.tabViewRef.tabs;
      const selectedTabTemp = tabComponent[tabIndex].props.key;

      if (selectedTabTemp != undefined) {
        this.selectedTab = selectedTabTemp;
        this.getData();
      } else {
        console.log("Header tab not found");
      }
    },
    renderMap() {
      var mapDiv = document.getElementById("map_canvas");
      setTimeout(() => {
        if (!mapDiv) {
          this.renderMap();
        } else {
          this.initMap();
        }
      }, 2000);
    },
    changeDept(e) {
      if (e == null) {
        this.header.AreaId = "";
        this.header.SubArea = "";
      } else {
        this.header.AreaId = e.id;
        this.header.SubArea = "";
      }
    },
    changePermitMethod(e) {
      if (e == null) {
        this.header.IsOnline = "Y";
        this.isOnlinePermitChecklist = "Y";
      } else {
        this.header.IsOnline = e.id;
        this.isOnlinePermitChecklist = e.id;
      }
    },
    convertDate(date) {
      return moment(date).format("DD/MM/YYYY H:m:s").toString();
    },
    changeFireWathcer(e) {
      if (e == null) {
        this.header.FirewatcherUserId = "";
      } else {
        this.header.FirewatcherUserId = e.id;
      }
    },
    isMtc(event) {
      if (this.header.Mtc == "N") {
        this.isMtcPermit = "N";
        return false;
      } else {
        this.isMtcPermit = "Y";
        return true;
      }
    },
    saveData() {
      this.$emit("blockBody");
      var self = this;

      var data = new FormData();

      if (this.mode != this.$FORM_MODE_DELETE) {
        this.header.PermitLogs = null;
        this.header.ApprovalLogs = null;

        if (this.sectionTab == this.$TAB_SECTION.WORKER) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);

          if (this.header.PermitWorkers.length > 0) {
            for (var i = 0; i < this.header.PermitWorkers.length; i++) {
              var item = this.header.PermitWorkers[i];
              data.append("PermitWorkers[" + i + "][Id]", item.Id);
              data.append("PermitWorkers[" + i + "][Role]", item.Role);
              data.append("PermitWorkers[" + i + "][Name]", item.Name);
              data.append("PermitWorkers[" + i + "][mode]", item.mode);
              data.append("PermitWorkers[" + i + "][PermitId]", this.header.Id);
            }
          }
        } else if (this.sectionTab == this.$TAB_SECTION.AGT) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);

          if (this.header.AgtPerson.length > 0) {
            for (var i = 0; i < this.header.AgtPerson.length; i++) {
              var item = this.header.AgtPerson[i];
              data.append("AgtPerson[" + i + "][Id]", item.Id);
              data.append("AgtPerson[" + i + "][AgtId]", item.AgtId);
              data.append("AgtPerson[" + i + "][mode]", item.mode);
              data.append("AgtPerson[" + i + "][PermitId]", this.header.Id);
            }
          }
        } else if (this.sectionTab == this.$TAB_SECTION.TOOLS) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);

          if (this.header.PermitToolsDetail.length > 0) {
            for (var i = 0; i < this.header.PermitToolsDetail.length; i++) {
              var item = this.header.PermitToolsDetail[i];
              data.append("PermitToolsDetail[" + i + "][Id]", item.Id);
              data.append("PermitToolsDetail[" + i + "][ToolId]", item.ToolId);
              data.append("PermitToolsDetail[" + i + "][Name]", item.Name);
              data.append("PermitToolsDetail[" + i + "][Qty]", item.Qty);
              data.append(
                "PermitToolsDetail[" + i + "][Condition]",
                item.Condition
              );
              data.append("PermitToolsDetail[" + i + "][Remark]", item.Remark);
              data.append("PermitToolsDetail[" + i + "][mode]", item.mode);
              data.append(
                "PermitToolsDetail[" + i + "][PermitId]",
                this.header.Id
              );
            }
          }
        } else if (this.sectionTab == this.$TAB_SECTION.SPV) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);

          if (this.header.PermitSupervisions.length > 0) {
            for (var i = 0; i < this.header.PermitSupervisions.length; i++) {
              var item = this.header.PermitSupervisions[i];
              data.append("PermitSupervisions[" + i + "][Id]", item.Id);
              data.append(
                "PermitSupervisions[" + i + "][SupervisorName]",
                item.SupervisorName
              );
              data.append(
                "PermitSupervisions[" + i + "][SupervisorRole]",
                item.SupervisorRole
              );
              data.append("PermitSupervisions[" + i + "][mode]", item.mode);
              data.append(
                "PermitSupervisions[" + i + "][PermitId]",
                this.header.Id
              );
            }
          }
        } else if (this.sectionTab == this.$TAB_SECTION.RISK) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);

          if (this.header.PermitRiskAsseses.length > 0) {
            this.header.PermitRiskAsseses.forEach((item, index) => {
              for (const key in item) {
                if (item.hasOwnProperty(key) && item[key] !== null) {
                  data.append(`PermitRiskAsseses[${index}][${key}]`, item[key]);
                }
              }
            });
          }
        } else if (this.sectionTab == this.$TAB_SECTION.CHECKLIST) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);
          data.append("IsOnline", this.header.IsOnline);

          if (this.isOnlinePermitChecklist == "Y") {
            if (this.header.PermitChecklists.length > 0) {
              this.header.PermitChecklists.forEach((item, index) => {
                for (const key in item) {
                  if (item.hasOwnProperty(key) && item[key] !== null) {
                    data.append(
                      `PermitChecklists[${index}][${key}]`,
                      item[key]
                    );
                  }
                }
              });
            }
          } else {
            if (this.docPreModel.length > 0) {
              for (var x = 0; x < this.docPreModel.length; x++) {
                var file1 = this.docPreModel[x];
                data.append("attachmentsPre.File", file1, file1.name);
              }
            }

            if (this.docDurPostModel.length > 0) {
              for (var y = 0; y < this.docDurPostModel.length; y++) {
                var file2 = this.docDurPostModel[y];
                data.append("attachmentsDurPost.File", file2, file2.name);
              }
            }
          }
        } else if (this.sectionTab == this.$TAB_SECTION.ENTRANCE) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);

          if (this.header.Entrances.length > 0) {
            for (var i = 0; i < this.header.Entrances.length; i++) {
              var item = this.header.Entrances[i];

              data.append("Entrances[" + i + "][Id]", item.Id);
              data.append("Entrances[" + i + "][mode]", item.mode);
              data.append("Entrances[" + i + "][PermitId]", this.header.Id);
              data.append("Entrances[" + i + "][Remark]", item.Remark);
              data.append("Entrances[" + i + "][WorkerId]", item.WorkerId);
              data.append(
                "Entrances[" + i + "][PersonnelName]",
                item.PersonnelName
              );

              if (item.TimeIn != null) {
                var localTimeIn = moment(item.TimeIn, "YYYY-MM-DDTHH:mm:ssZ");
                var getExtTimeIn = moment(localTimeIn)
                  .subtract(this.timezoneUserOffset, "hours")
                  .format("HH:mm")
                  .toString();
                data.append("Entrances[" + i + "][TimeIn]", getExtTimeIn);
              }

              if (item.TimeOut != null) {
                var localTimeOut = moment(item.TimeOut, "YYYY-MM-DDTHH:mm:ssZ");
                var getExtTimeOut = moment(localTimeOut)
                  .subtract(this.timezoneUserOffset, "hours")
                  .format("HH:mm")
                  .toString();
                data.append("Entrances[" + i + "][TimeOut]", getExtTimeOut);
              }
            }
          }
        } else if (this.sectionTab == this.$TAB_SECTION.ATM) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);

          if (this.header.AtmControls.length > 0) {
            this.header.AtmControls.forEach((item, index) => {
              for (const key in item) {
                if (item.hasOwnProperty(key) && item[key] !== null) {
                  data.append(`AtmControls[${index}][${key}]`, item[key]);
                }
              }
            });
          }
        } else if (this.sectionTab == this.$TAB_SECTION.SOP) {
          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);

          if (this.header.PermitSopss.length > 0) {
            this.header.PermitSopss.forEach((item, index) => {
              for (const key in item) {
                if (item.hasOwnProperty(key) && item[key] !== null) {
                  data.append(`PermitSopss[${index}][${key}]`, item[key]);
                }
              }
            });
          }
        } else if (this.sectionTab == this.$TAB_SECTION.EXTEND) {
          this.header.PermitToolsDetail = null;
          this.header.PermitRiskAsseses = null;
          this.header.PermitSopss = null;
          this.header.PermitSupervisions = null;
          this.header.PermitWorkers = null;
          this.header.Entrances = null;
          this.header.PermitChecklists = null;
          this.header.AtmControls = null;

          data.append("Id", this.header.Id);
          data.append("mode", this.header.mode);
          data.append("tabSection", this.sectionTab);
          data.append("IsExtend", this.header.IsExtend);
          data.append("ExtDesc", this.header.ExtDesc);

          if (this.header.ExtStartTime != null) {
            var localExtStartTime = moment(
              this.header.ExtStartTime,
              "YYYY-MM-DDTHH:mm:ssZ"
            );
            var getExtStartTime = moment(localExtStartTime)
              .subtract(this.timezoneUserOffset, "hours")
              .format("HH:mm")
              .toString();
            data.append("ExtStartTime", getExtStartTime);
          }

          if (this.header.ExtFinsihTime != null) {
            var localExtFinsihTime = moment(
              this.header.ExtFinsihTime,
              "YYYY-MM-DDTHH:mm:ssZ"
            );
            var getExtFinsihTime = moment(localExtFinsihTime)
              .subtract(this.timezoneUserOffset, "hours")
              .format("HH:mm")
              .toString();
            data.append("ExtFinsihTime", getExtFinsihTime);
          }
        } else if (this.sectionTab == this.$TAB_SECTION.HEADER) {
          this.header.PermitToolsDetail = null;
          this.header.PermitRiskAsseses = null;
          this.header.PermitSopss = null;
          this.header.PermitSupervisions = null;
          this.header.PermitWorkers = null;
          this.header.Entrances = null;
          this.header.PermitChecklists = null;
          this.header.AtmControls = null;

          this.appendFormData(data, this.header);
          data.append("tabSection", this.sectionTab);
          data.append("TimeZoneOffset", this.timezoneUserOffset);
          data.append(
            "PermitDate",
            moment(this.header.PermitDate).format("YYYY/MM/DD").toString()
          );

          var localStartTime = moment(
            this.header.StartTime,
            "YYYY-MM-DDTHH:mm:ssZ"
          );
          var getStartTime = moment(localStartTime)
            .subtract(this.timezoneUserOffset, "hours")
            .format("HH:mm")
            .toString();
          data.append("StartTime", getStartTime);

          var localFinishTime = moment(
            this.header.FinishTime,
            "YYYY-MM-DDTHH:mm:ssZ"
          );
          var getFinishTime = moment(localFinishTime)
            .subtract(this.timezoneUserOffset, "hours")
            .format("HH:mm")
            .toString();
          data.append("FinishTime", getFinishTime);

          if (this.header.ReqEntryTime != null) {
            var localReqEntryTime = moment(
              this.header.ReqEntryTime,
              "YYYY-MM-DDTHH:mm:ssZ"
            );
            var getReqEntryTime = moment(localReqEntryTime)
              .subtract(this.timezoneUserOffset, "hours")
              .format("HH:mm")
              .toString();
            data.append("ReqEntryTime", getReqEntryTime);
          }

          if (this.header.ReqLeaveTime != null) {
            var localReqLeaveTime = moment(
              this.header.ReqLeaveTime,
              "YYYY-MM-DDTHH:mm:ssZ"
            );
            var getReqLeaveTime = moment(localReqLeaveTime)
              .subtract(this.timezoneUserOffset, "hours")
              .format("HH:mm")
              .toString();
            data.append("ReqLeaveTime", getReqLeaveTime);
          }

          if (this.header.ExtStartTime != null) {
            var localExtStartTime = moment(
              this.header.ExtStartTime,
              "YYYY-MM-DDTHH:mm:ssZ"
            );
            var getExtStartTime = moment(localExtStartTime)
              .subtract(this.timezoneUserOffset, "hours")
              .format("HH:mm")
              .toString();
            data.append("ExtStartTime", getExtStartTime);
          }

          if (this.header.ExtFinsihTime != null) {
            var localExtFinsihTime = moment(
              this.header.ExtFinsihTime,
              "YYYY-MM-DDTHH:mm:ssZ"
            );
            var getExtFinsihTime = moment(localExtFinsihTime)
              .subtract(this.timezoneUserOffset, "hours")
              .format("HH:mm")
              .toString();
            data.append("ExtFinsihTime", getExtFinsihTime);
          }

          if (this.header.GasTesterCalibrationDate != null) {
            data.append(
              "GasTesterCalibrationDate",
              moment(this.header.GasTesterCalibrationDate)
                .format("YYYY/MM/DD")
                .toString()
            );
          }
          //  var permitInput = this.header;

          if (this.imgCloseModel.length > 0) {
            for (var x = 0; x < this.imgCloseModel.length; x++) {
              var file1 = this.imgCloseModel[x];
              data.append("attachmentsClose.File", file1, file1.name);
            }
          }
        }
      } else {
        data.append("Id", this.header.Id);
        data.append("mode", this.header.mode);
      }

      this.$axios
        .post(this.url, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success) {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "success",
              summary: "Data Saved",
              detail: response.data.message,
              life: 3000,
            });
            if (
              self.mode == self.$FORM_MODE_DELETE ||
              self.permitStatus == "REJ"
            ) {
              self.backToIndex();
            } else {
              self.getData();
              self.visible = false;
            }
          } else {
            self.showError(response.data.message);
          }
        })
        .catch(function (error) {
          self.showError(error);
        });
    },
    appendFormData(data, header, parentKey = null) {
      for (const key in header) {
        const value = header[key];
        const propName = parentKey ? `${parentKey}[${key}]` : key;

        if (value instanceof File) {
          // Handle file input
          data.append(propName, value);
        } else if (typeof value === "object") {
          // Recursively handle nested objects

          // Check for PermitWorker and PermitTools objects specifically
          // if (
          //     propName.includes("PermitWorkers") ||
          //     propName.includes("PermitSupervisions") ||
          //     propName.includes("PermitToolsDetail") ||
          //     propName.includes("PermitRiskAsseses") ||
          //     propName.includes("Entrances") ||
          //     propName.includes("PermitChecklists") ||
          //     propName.includes("AtmControls")
          // ) {
          //     if (value) {
          //         if (value.mode === "Unchanged") {
          //             console.log(propName)
          //             // Skip appending PermitWorker or PermitTools objects with mode Unchanged
          //             continue;
          //         }

          //     }
          // }

          if (
            !propName.includes("ApprovalLogs") ||
            !propName.includes("PermitLogs")
          ) {
            this.appendFormData(data, value, propName);
          }
        } else {
          // Append simple values
          if (propName == "StartTime") {
            var localStartTime = moment(value, "YYYY-MM-DDTHH:mm:ssZ");
            var getStartTime = moment(localStartTime)
              .subtract(this.timezoneUserOffset, "hours")
              .format("HH:mm")
              .toString();
            value = getStartTime;
          } else if (propName == "FinishTime") {
            var localFinishTime = moment(value, "YYYY-MM-DDTHH:mm:ssZ");
            var getFinishTime = moment(localFinishTime)
              .subtract(this.timezoneUserOffset, "hours")
              .format("HH:mm")
              .toString();
            value = getFinishTime;
          } else if (propName == "ReqEntryTime") {
            if (value != null) {
              var localReqEntryTime = moment(value, "YYYY-MM-DDTHH:mm:ssZ");
              var getlocalReqEntryTime = moment(localReqEntryTime)
                .subtract(this.timezoneUserOffset, "hours")
                .format("HH:mm")
                .toString();
              value = getlocalReqEntryTime;
            }
          } else if (propName == "ReqLeaveTime") {
            if (value != null) {
              var localReqLeaveTime = moment(value, "YYYY-MM-DDTHH:mm:ssZ");
              var getlocalReqLeaveTime = moment(localReqLeaveTime)
                .subtract(this.timezoneUserOffset, "hours")
                .format("HH:mm")
                .toString();
              value = getlocalReqLeaveTime;
            }
          } else if (propName == "ExtStartTime") {
            if (value != null) {
              var localExtStartTime = moment(value, "YYYY-MM-DDTHH:mm:ssZ");
              var getlocalExtStartTime = moment(localExtStartTime)
                .subtract(this.timezoneUserOffset, "hours")
                .format("HH:mm")
                .toString();
              value = getlocalExtStartTime;
            }
          } else if (propName == "ExtFinsihTime") {
            if (value != null) {
              var localExtFinsihTime = moment(value, "YYYY-MM-DDTHH:mm:ssZ");
              var getlocalExtFinsihTime = moment(localExtFinsihTime)
                .subtract(this.timezoneUserOffset, "hours")
                .format("HH:mm")
                .toString();
              value = getlocalExtFinsihTime;
            }
          }

          if (propName.includes("[TimeIn]")) {
            if (value != null) {
              var localTimeIn = moment(value, "YYYY-MM-DDTHH:mm:ssZ");
              var getlocalTimeIn = moment(localTimeIn)
                .subtract(this.timezoneUserOffset, "hours")
                .format("HH:mm")
                .toString();
              value = getlocalTimeIn;
            }
          } else if (propName.includes("[TimeOut]")) {
            if (value != null) {
              var localTimeOut = moment(value, "YYYY-MM-DDTHH:mm:ssZ");
              var getlocalTimeOut = moment(localTimeOut)
                .subtract(this.timezoneUserOffset, "hours")
                .format("HH:mm")
                .toString();
              value = getlocalTimeOut;
            }
          } else if (propName.includes("QrCodePermit")) {
            value = null;
          }

          data.append(propName, value);
        }
      }
    },
    backToIndex() {
      this.$router.push({ path: "/Permit/Index" });
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    confirm(event) {
      if (this.mode != this.$FORM_MODE_DELETE) {
        this.submitted = true;
        this.sectionTab = this.$TAB_SECTION.HEADER;
        if (this.header.Version == "1") {
          if (
            !this.header.GivenTo ||
            !this.header.PermitDate ||
            !this.header.Description ||
            !this.header.Title
          ) {
            return false;
          } else {
            if (this.header.IsExtend == "Y") {
              if (
                !this.header.ExtStartTime ||
                !this.header.ExtFinsihTime ||
                !this.header.ExtDesc
              ) {
                return false;
              } else {
                this.$confirm.require({
                  target: event.currentTarget,
                  message: "Are you sure?",
                  icon: "pi pi-exclamation-triangle",
                  accept: () => {
                    this.saveData();
                  },
                  reject: () => {
                    //callback to execute when user rejects the action
                  },
                });
              }
            } else {
              this.$confirm.require({
                target: event.currentTarget,
                message: "Are you sure?",
                icon: "pi pi-exclamation-triangle",
                accept: () => {
                  this.saveData();
                },
                reject: () => {
                  //callback to execute when user rejects the action
                },
              });
            }
          }
        } else {
          if (
            !this.header.PermitDate ||
            !this.header.Description ||
            !this.header.Title
          ) {
            return false;
          } else {
            this.$confirm.require({
              target: event.currentTarget,
              message: "Are you sure?",
              icon: "pi pi-exclamation-triangle",
              accept: () => {
                this.saveData();
              },
              reject: () => {
                //callback to execute when user rejects the action
              },
            });
          }
        }
      } else {
        this.$confirm.require({
          target: event.currentTarget,
          message: "Are you sure?",
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            this.saveData();
          },
          reject: () => {
            //callback to execute when user rejects the action
          },
        });
      }
    },
    confirmResubmit(event) {
      this.visible = true;
    },
    confirmVerif(event, section) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          if (section == "COM") {
            this.completePermit();
          } else {
            this.verifData(section);
          }
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    confirmSection(event, section) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          if (section == this.$TAB_SECTION.WORKER) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.TOOLS) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.SPV) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.RISK) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.CHECKLIST) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.ENTRANCE) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.ATM) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.SOP) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.AGT) {
            this.sectionTab = section;
          } else if (section == this.$TAB_SECTION.EXTEND) {
            this.sectionTab = section;
          } else {
            this.sectionTab = this.$TAB_SECTION.HEADER;
          }

          this.saveData();
        },
        reject: () => {
          this.sectionTab = null;
          //callback to execute when user rejects the action
        },
      });
    },
    verifData(section) {
      this.$emit("blockBody");
      var self = this;

      this.dataModelVerif = {
        PermitId: this.header.Id,
        Section: section,
        UserId: this.idUser,
      };

      this.$axios
        .post(this.urlVerif, this.dataModelVerif)
        .then((response) => {
          if (response.data.success) {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "success",
              summary: "Verification Success",
              detail: response.data.message,
              life: 3000,
            });
            self.getData();
          } else {
            self.showError(response.data.message);
          }
        })
        .catch(function (error) {
          self.showError(error);
        });
    },
    completePermit() {
      this.$emit("blockBody");
      var self = this;

      this.dataModelPermit = {
        Id: this.header.Id,
        CompanyCode: this.header.CompanyCode,
        WorkId: this.header.WorkId,
      };

      this.$axios
        .post(this.urlComplete, this.dataModelPermit)
        .then((response) => {
          if (response.data.success) {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "success",
              summary: "Complete Permit Success",
              detail: response.data.message,
              life: 3000,
            });
            self.getData();
          } else {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "error",
              summary: "Error Permit Close",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .catch(function (error) {
          self.showError(error);
        });
    },
    signoff(event) {
      this.$emit("blockBody");
      var self = this;

      this.dataModelSignOff = {
        Id: this.header.Id,
        Mode: this.header.mode,
        AgreementDeclaration: this.header.AgreementDeclaration,
      };

      this.$axios
        .post(this.urlSignOff, this.dataModelSignOff)
        .then((response) => {
          if (response.data.success) {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "success",
              summary: "SignOff Success",
              detail: response.data.message,
              life: 3000,
            });
            self.getData();
          } else {
            self.showError(response.data.message);
          }
        })
        .catch(function (error) {
          self.showError(error);
        });
    },
    confirmFireWatcher(event) {
      this.$emit("blockBody");
      var self = this;

      this.dataModelFireWather = {
        Id: this.header.Id,
        Mode: this.header.mode,
        CompanyCode: this.header.CompanyCode,
        FirewatcherUserId: this.header.FirewatcherUserId,
      };

      this.$axios
        .post(this.urlConfirmFire, this.dataModelFireWather)
        .then((response) => {
          if (response.data.success) {
            this.$emit("unblockBody");
            self.$toast.add({
              severity: "success",
              summary: "Fire Wartcher Confirmation Success",
              detail: response.data.message,
              life: 3000,
            });
            self.getData();
          } else {
            self.showError(response.data.message);
          }
        })
        .catch(function (error) {
          self.showError(error);
        });
    },
    confirmSuspend(event, section) {
      this.visibleExtend = true;
      // this.$confirm.require({
      //             target: event.currentTarget,
      //             message: 'Are you sure?',
      //             icon: 'pi pi-exclamation-triangle',
      //             accept: () => {
      //                 this.suspendData(section);

      //             },
      //             reject: () => {
      //                 //callback to execute when user rejects the action
      //             }
      // });
    },
    confirmClean(event, section) {
      this.visibleClean = true;
      // this.$confirm.require({
      //             target: event.currentTarget,
      //             message: 'Are you sure?',
      //             icon: 'pi pi-exclamation-triangle',
      //             accept: () => {
      //                 this.suspendData(section);

      //             },
      //             reject: () => {
      //                 //callback to execute when user rejects the action
      //             }
      // });
    },
    confirmResetVerif(event, section) {
      this.visibleResetVerif = true;
      // this.$confirm.require({
      //             target: event.currentTarget,
      //             message: 'Are you sure?',
      //             icon: 'pi pi-exclamation-triangle',
      //             accept: () => {
      //                 this.suspendData(section);

      //             },
      //             reject: () => {
      //                 //callback to execute when user rejects the action
      //             }
      // });
    },
    suspendData() {
      this.$emit("blockBody");
      var self = this;

      var statusCheck = "";

      if (this.permitStatus != "SUS") {
        statusCheck = "SUS";
      } else if (this.permitStatus == "SUS") {
        statusCheck = "UNSUS";
      }

      this.dataModelVerif = {
        Id: this.header.Id,
        CompanyCode: this.header.CompanyCode,
        WorkId: this.header.WorkId,
        Status: statusCheck,
        UserId: this.idUser,
        commentRevise: this.header.commentRevise,
      };

      this.$axios
        .post(this.urlSuspend, this.dataModelVerif)
        .then((response) => {
          if (response.data.success) {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "success",
              summary: "Suspend Success",
              detail: response.data.message,
              life: 3000,
            });
            self.getData();
            self.visibleExtend = false;
          } else {
            self.showError(response.data.message);
            self.visibleExtend = false;
          }
        })
        .catch(function (error) {
          self.showError(error);
          self.visibleExtend = false;
        });
    },
    resetVerifData() {
      this.$emit("blockBody");
      var self = this;

      this.dataModelVerif = {
        Id: this.header.Id,
        CompanyCode: this.header.CompanyCode,
        WorkId: this.header.WorkId,
        UserId: this.idUser,
        commentRevise: this.header.commentRevise,
      };

      this.$axios
        .post(this.urlResetVerif, this.dataModelVerif)
        .then((response) => {
          if (response.data.success) {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "success",
              summary: "Reset Verification Success",
              detail: response.data.message,
              life: 3000,
            });
            self.getData();
            self.visibleResetVerif = false;
          } else {
            self.showError(response.data.message);
            self.visibleResetVerif = false;
          }
        })
        .catch(function (error) {
          self.showError(error);
          self.visibleResetVerif = false;
        });
    },
    cleanApprover() {
      this.$emit("blockBody");
      var self = this;

      this.dataModelVerif = {
        Id: this.header.Id,
        CompanyCode: this.header.CompanyCode,
        WorkId: this.header.WorkId,
        UserId: this.idUser,
        commentRevise: this.header.commentRevise,
      };

      this.$axios
        .post(this.urlCleanApv, this.dataModelVerif)
        .then((response) => {
          if (response.data.success) {
            self.$emit("unblockBody");
            self.$toast.add({
              severity: "success",
              summary: "Clean Approvers Success",
              detail: response.data.message,
              life: 3000,
            });
            self.getData();
            self.visibleClean = false;
          } else {
            self.showError(response.data.message);
            self.visibleClean = false;
          }
        })
        .catch(function (error) {
          self.showError(error);
          self.visibleClean = false;
        });
    },
    addDetail() {
      var newDetail = this.dataModel;
      newDetail.mode = this.$FORM_MODE_CREATE;
      var det = { ...newDetail };

      this.header.Details.push(det);
    },
    deleteDetail(event) {
      if (event) {
        var detail = this.header.Details[event.index];

        if (detail.mode == this.$FORM_MODE_CREATE)
          this.header.Details.splice(this.header.Details.indexOf(detail), 1);
        else detail.mode = this.$FORM_MODE_DELETE;
      }
    },
    onCellEditComplete(event) {
      this.editDetail(event.index);
    },
    onFileSelectImgJsea(event, header) {
      this.docJseaModel = [];
      for (var i = 0; i < event.files.length; i++) {
        this.docJseaModel.push(event.files[i]);
      }
    },
    onFileRemoveImgJsea(files, data) {
      this.docJseaModel = [];
      for (var i = 0; i < files.length; i++) {
        this.docJseaModel.push(event.files[i]);
      }
    },
    onFileSelectImgOpn(event) {
      this.imgOpenModel = event.files;
    },
    onFileRemoveImgOpn() {
      this.imgOpenModel = [];
    },
    onFileSelectImgClose(event, header) {
      this.imgCloseModel = [];
      for (var i = 0; i < event.files.length; i++) {
        this.imgCloseModel.push(event.files[i]);
      }
    },
    onFileRemoveImgClose(files, data) {
      this.imgCloseModel = [];
      for (var i = 0; i < files.length; i++) {
        this.imgCloseModel.push(event.files[i]);
      }
    },
    onFileSelectClosePermit(event, header) {
      this.docClosePermitModel = [];
      for (var i = 0; i < event.files.length; i++) {
        this.docClosePermitModel.push(event.files[i]);
      }
    },
    onFileRemoveClosePermit(files, data) {
      this.docClosePermitModel = [];
      for (var i = 0; i < files.length; i++) {
        this.docClosePermitModel.push(event.files[i]);
      }
    },
    onFileSelectUpload(event) {
      this.detailFiles = event.files;
      this.uploadFile = true;
    },
    dismissConfirmation() {
      this.visible = false;
      this.header.commentRevise = null;
    },
    dismissSuspend() {
      this.visibleExtend = false;
      this.header.commentRevise = null;
    },
    dismissResetVerif() {
      this.visibleResetVerif = false;
      this.header.commentRevise = null;
    },
    dismissClean() {
      this.visibleClean = false;
      this.header.commentRevise = null;
    },
    onDownloadFile(file) {
      this.$emit("block-ui");
      //console.log(file)
      var self = this;
      this.$axios
        .get(
          this.url +
            "download_currently/" +
            file.id +
            "/" +
            file.name +
            "/complate",
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.name);
          document.body.appendChild(link);
          link.click();
          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    editDetail(index) {
      if (this.header.Details && this.header.Details.length > 0) {
        let m = this.header.Details[index].mode;

        if (m == this.$FORM_MODE_UNCHANGED) {
          this.header.Details[index].mode = this.$FORM_MODE_EDIT;
        }
      }
    },
    initMap() {
      var floatCoord = [];
      let marker = [];
      let mapContainer = document.getElementById("map_canvas");
      var self = this;

      this.$maps_loader.load().then(() => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // This event listener calls addMarker() when the map is clicked.
              var marker = null;
              var pos2 = [];
              var driverPath = [];

              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };

              let map = new google.maps.Map(mapContainer, {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoom: 13,
                center: new google.maps.LatLng(pos.lat, pos.lng),
              });

              if (self.mode == self.$FORM_MODE_VERIFY) {
                // Add a marker at the center of the map.
                const userLocation = new google.maps.Marker({
                  position: pos,
                  map,
                  title: "Your Location Now",
                  label: "You",
                });

                pos2 = {
                  lat: parseFloat(self.header.PermitLat),
                  lng: parseFloat(self.header.PermitLong),
                };

                //Add a circle (radius) around the marker
                const circle = new google.maps.Circle({
                  map: map,
                  center: pos2,
                  radius: 3000, // Set the radius in meters (adjust as needed)
                  strokeColor: "#4285F4",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: "#4285F4",
                  fillOpacity: 0.35,
                });
              }

              if (
                self.header &&
                self.header.PermitLat &&
                self.header.PermitLong
              ) {
                // Trigger a click event on the map at the specified coordinates
                google.maps.event.trigger(map, "click", {
                  latLng: new google.maps.LatLng(
                    parseFloat(self.header.PermitLat),
                    parseFloat(self.header.PermitLong)
                  ),
                });

                pos2 = {
                  lat: parseFloat(self.header.PermitLat),
                  lng: parseFloat(self.header.PermitLong),
                };

                marker = new google.maps.Marker({
                  position: pos2,
                  map,
                  title: "Your Company Location",
                  label: "Company",
                });

                if (self.mode == self.$FORM_MODE_VERIFY) {
                  driverPath = new google.maps.Polyline({
                    path: [pos, pos2],
                    geodesic: true,
                    strokeColor: "#FF0000",
                    strokeOpacity: 1.0,
                    strokeWeight: 3,
                  });
                  driverPath.setMap(map);

                  //count distance using Googlemaps Matrix Service
                  // var service = new google.maps.DistanceMatrixService();
                  // var distanceResult = service.getDistanceMatrix({
                  //     origins: [pos],
                  //     destinations: [pos2],
                  //     travelMode: 'DRIVING',
                  //     unitSystem: google.maps.UnitSystem.IMPERIAL,
                  // });

                  // distanceResult.then(function (result) {
                  //     var response = result.rows[0].elements[0];
                  //     if (result) {
                  //         self.distanceMi = Math.round(parseFloat(result.rows[0].elements[0].distance.text) * parseFloat(1609.34)); // "Some User token"
                  //     }
                  // }).catch(error => {
                  //     console.error('Error:', error);
                  // });

                  //count distance using Haversine Formula
                  const distanceInMeters = self.getDistanceInMeters(pos, pos2);
                  const roundedDistance = Math.round(distanceInMeters); // Pembulatan jarak ke meter terdekat
                  self.distanceMi = roundedDistance;
                }
              }

              if (
                self.mode == self.$FORM_MODE_CREATE ||
                self.mode == self.$FORM_MODE_EDIT
              ) {
                google.maps.event.addListener(map, "click", (event) => {
                  if (marker) {
                    marker.setMap(null);
                    if (self.mode == self.$FORM_MODE_VERIFY) {
                      driverPath.setMap(null);
                    }
                  }

                  marker = new google.maps.Marker({
                    position: event.latLng,
                    map,
                    title: "Your Company Location",
                    label: "Company",
                  });

                  if (marker) {
                    pos2 = {
                      lat: marker.getPosition().lat(),
                      lng: marker.getPosition().lng(),
                    };

                    this.header.PermitLat = marker.getPosition().lat();
                    this.header.PermitLong = marker.getPosition().lng();
                  }

                  if (self.mode == self.$FORM_MODE_VERIFY) {
                    driverPath = new google.maps.Polyline({
                      path: [pos, pos2],
                      geodesic: true,
                      strokeColor: "#FF0000",
                      strokeOpacity: 1.0,
                      strokeWeight: 3,
                    });
                    driverPath.setMap(map);

                    //count distance using Googlemaps Matrix Service
                    // var service = new google.maps.DistanceMatrixService();
                    // var distanceResult = service.getDistanceMatrix({
                    //     origins: [pos],
                    //     destinations: [pos2],
                    //     travelMode: 'DRIVING',
                    //     unitSystem: google.maps.UnitSystem.IMPERIAL,
                    // });

                    // distanceResult.then(function (result) {
                    //     if (result) {
                    //         self.distanceMi = Math.round(parseFloat(result.rows[0].elements[0].distance.text) * parseFloat(1609.34)); // "Some User token"
                    //     }
                    // }).catch(error => {
                    //     console.error('Error:', error);
                    // });

                    //count distance using Haversine Formula
                    const distanceInMeters = self.getDistanceInMeters(
                      pos,
                      pos2
                    );
                    const roundedDistance = Math.round(distanceInMeters); // Pembulatan jarak ke meter terdekat
                    self.distanceMi = roundedDistance;
                  }
                });
              }
            },
            () => {
              // handleLocationError(true, infoWindow, map.getCenter());
            }
          );
        }
      });
    },
    getDistanceInMeters(origin, destination) {
      const R = 6371e3; // Radius bumi dalam meter
      const φ1 = (origin.lat * Math.PI) / 180; // φ, λ dalam radian
      const φ2 = (destination.lat * Math.PI) / 180;
      const Δφ = ((destination.lat - origin.lat) * Math.PI) / 180;
      const Δλ = ((destination.lng - origin.lng) * Math.PI) / 180;

      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const distance = R * c; // Jarak dalam meter
      return distance;
    },
    createLegend(map) {
      const icons = {
        source: {
          name: "Source",
          icon: require("@/assets/maps_pin_a.png"),
        },
        dest: {
          name: "Destination",
          icon: require("@/assets/maps_pin_b.png"),
        },
        redLine: {
          name: "Driver Path",
          icon: require("@/assets/maps_red_line.png"),
        },
        blueLine: {
          name: "Recomendation Path",
          icon: require("@/assets/maps_blue_line.png"),
        },
      };

      const legend = document.getElementById("legend");
      for (var key in icons) {
        var type = icons[key];
        var name = type.name;
        var icon = type.icon;

        var div = document.createElement("div");
        div.style.cssText +=
          "display:flex;align-items:center;margin-bottom:10px";
        div.innerHTML = `<img style="max-width:50px !important;margin-right:10px" src="${icon}"></img><span style="font-size:12px"> ${name}</span>`;

        legend.appendChild(div);
      }

      map.controls[google.maps.ControlPosition.LEFT_TOP].push(legend);
      return icons;
    },
    drawDirectionRoute(coordinates, map) {
      var directionsDisplay = new google.maps.DirectionsRenderer();
      var service = new google.maps.DirectionsService();
      var start = new google.maps.LatLng(coordinates[0]);
      var end = new google.maps.LatLng(coordinates[coordinates.length - 1]);
      var request = {
        origin: start,
        destination: end,
        travelMode: google.maps.TravelMode.DRIVING,
      };
      service.route(request, function (response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
        }
      });
      directionsDisplay.setMap(map);
    },
    expandLegend() {
      var legend = document.getElementById("legend");
      legend.classList.toggle("expand");
    },
    getDenyOSPermit() {
      var self = this;

      this.$axios
        .get(this.urlOsPermit + "/" + this.id)
        .then((response) => {
          if (response.data.success) {
            self.isHaveOsPermit = false;
          } else {
            if (response.data.message_code == "HAVE_OS_PERMIT") {
              self.dataPermitOS = response.data.data;
              self.isHaveOsPermit = true;
              self.errMessage = response.data.message;
            }
          }
          this.$emit("unblock-ui");
        })
        .catch((err) => {
          this.$emit("unblock-ui");
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
        });
    },
    goToDetail(event) {
      var data = event.data;
      let routeData = this.$router.resolve({
        name: "PermitEditor",
        query: { mode: this.$FORM_MODE_VIEW, id: data.permitId },
      });
      window.open(routeData.href, "_blank");
    },
    showError(message) {
      this.$emit("unblockBody");
      this.$parent.$toast.add({
        severity: "error",
        summary: "Error",
        detail: message,
        life: 3000,
      });
    },
    sidebarMessage(event) {
      this.$toast.add(event);
    },
    getmap(event) {
      this.initMap();
    },
    onFileSelectDocPre(event) {
      this.docPreModel = event.files;
    },
    onFileRemoveDocPre() {
      this.docPreModel = [];
    },
    onFileSelectDocDurPost(event) {
      this.docDurPostModel = event.files;
    },
    onFileRemoveDocDurPost() {
      this.docDurPostModel = [];
    },
    onDownloadFileDocPre(file) {
      this.$emit("block-ui");
      //console.log(file)

      var self = this;
      this.$axios
        .get(
          this.url + "download_currently/" + file.id + "/" + file.name + "/pre",
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          self.fileTypeView = self.getFileType(file.name);
          if (self.fileTypeView && self.fileTypeView.startsWith("image/")) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            self.fileUrlView = url;
            self.fileName = file.name;
            self.fileUrl = url;
            self.isImg = true;
          }

          if (self.fileTypeView === "application/pdf") {
            const blob = new Blob([response.data], { type: "application/pdf" });
            self.fileUrlView = window.URL.createObjectURL(blob);
            self.fileName = file.name;
            self.isPdf = true;
          }

          self.sectionFile = "Pre Permit Checklist";
          self.dialogVisibleView = true;

          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    onDownloadFileDocDurPost(file) {
      this.$emit("block-ui");
      //console.log(file)

      var self = this;
      this.$axios
        .get(
          this.url +
            "download_currently/" +
            file.id +
            "/" +
            file.name +
            "/durpost",
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          self.fileTypeView = self.getFileType(file.name);
          if (self.fileTypeView && self.fileTypeView.startsWith("image/")) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            self.fileUrlView = url;
            self.fileName = file.name;
            self.fileUrl = url;
            self.isImg = true;
          }

          if (self.fileTypeView === "application/pdf") {
            const blob = new Blob([response.data], { type: "application/pdf" });
            self.fileUrlView = window.URL.createObjectURL(blob);
            self.fileName = file.name;
            self.isPdf = true;
          }

          self.sectionFile = "Dur & Post Permit Checklist";
          self.dialogVisibleView = true;

          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    getTemplate(type) {
      this.$emit("block-ui");
      this.permitChecklistSection = type;
      this.showTemplatePC = true;
      this.$emit("unblock-ui");
      // this.headerTemplate.Document_Category = this.permitCategory;
      // var self = this;

      // this.$axios
      //   .post(this.urlTemplate, this.headerTemplate)
      //   .then((response) => {
      //     self.templateTbl = {
      //       header: response.data.data.header,
      //       content: response.data.data.content,
      //       title: response.data.data.title,
      //     };
      //     console.log(self.templateTbl);
      //     // this.showError(response);
      //     self.showTemplatePC = true;
      //     self.$emit("unblock-ui");
      //   })
      //   .catch((err) => {
      //     self.showError(err);
      //     self.$emit("unblock-ui");
      //   });
    },
    resetBtn() {
      this.showTemplatePC = false;
    },
    getFileType(fileName) {
      const extension = fileName.split(".").pop().toLowerCase();
      switch (extension) {
        case "pdf":
          return "application/pdf";
        case "jpg":
        case "jpeg":
          return "image/jpeg";
        case "png":
          return "image/png";
        default:
          return "application/octet-stream";
      }
    },
    hideViewer() {
      this.dialogVisibleView = false;
      this.fileUrl = null;
      this.fileName = null;
      this.fileTypeView = null;
      this.fileHref = null;
      this.isImg = false;
      this.isPdf = false;
    },
  },
  created() {
    this.mode = this.$route.query.mode;
    this.id = this.$route.query.id ?? 0;

    this.getData();

    if (this.mode == this.$FORM_MODE_EDIT) {
      this.getDenyOSPermit();
    }
  },
  computed: {
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
  },
};
</script>
<style type="text/css" scoped>
#map_canvas {
  height: 100%;
}

#legend {
  font-family: Arial, sans-serif;
  background: #fff;
  padding: 10px;
  margin: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 3px #00000026;
}

#legend h3 {
  margin-top: 0;
}

#legend img {
  vertical-align: middle;
}

.smalldesc {
  margin-top: 40px !important;
  height: 50px;
  width: 53px;
  overflow: hidden;
  transition: width 2s, height 2s;
}

.smalldesc:hover {
  background: #dddddd !important;
}

.smalldesc.expand {
  height: 250px;
  width: 200px;
}

.smalldesc hr {
  border-color: black;
}

#headerPermit {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#headerPermit td,
#headerPermit th {
  border: 1px solid #ddd;
  padding: 8px;
}

#headerPermit tr:nth-child(even) {
  background-color: #f2f2f2;
}

#headerPermit tr:hover {
  background-color: #ddd;
}

#headerPermit th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #04aa6d;
  color: white;
}
</style>
